import React from "react";
import { Button, Col, FormLabel, Row, Table } from "react-bootstrap";
import { AppContext } from "../AppContext.js";
import { ConfigManager } from "../config/ConfigManager.js";
import { NEW_ENTRY } from "../ds/App_Constants.js";
import { BaseBean, NodeData } from "../ds/client_ds.js";
import {
  CustomerReturnBean,
  CustomerReturnMerchandiseLineBean,
  CustomerReturnSearchCriteria,
  CustomerSearchCriteria,
  InvoiceBean,
  InvoiceSearchCriteria,
  PageListBean,
  ReasonBean,
  RestCustomerListRequest,
  RestCustomerReturnBeanRequest,
  RestCustomerReturnListRequest,
  RestEntityUnLockRequest,
  RestInvoiceListRequest,
  RestPageListBean,
  RestReadRequest,
} from "../ds/ds.js";
import { LogicConstants } from "../ds/LogicConstants.js";
import {
  AddIcon,
  DeleteIcon,
  DropDwnDown,
  DropDwnUp,
} from "../gui_components/Icons.js";
import {
  AlertToolBox,
  ColumnDefinition,
  DataGridColumnDefinition,
  DatePickerComponent,
  EditableDataGrid,
  InputTextbox,
  MultiViewPopup,
  NumberFormatInputbox,
  ProgressBar,
  ReasonCaptureComponent,
  ShortCutMenuPopup,
  ShowError,
} from "../gui_components/UIComponents.js";
import {
  isEmpty,
  isEmptyArray,
  isEmptyString,
  toCommaSeperatedAmount
} from "../gui_components/Util.js";
import {
  PopupCustomerCurrentAgingInq,
  PopupCustomerMostRecentFabricsInq,
  PopupCustomerOnOrderInq,
  PopupCustomerSalesHistoryInq,
  PopupCustomerStatisticsInq,
  PopupCustomerTransactionsInq,
} from "../Inquiry/InquiryUtil.js";
import { CustomerLookupHandler } from "../lookup/CustomerLookupHandler.js";
import { CustomerReturnLookupHandler } from "../lookup/CustomerReturnLookupHandler.js";
import { FabricStyleLookupHandler } from "../lookup/FabricStyleLookupHandler.js";
import { GenericAttributeLookupHandler } from "../lookup/GenericAttributeLookupHandler.js";
import { InvoiceLookupHandlers } from "../lookup/InvoiceLookupHandlers.js";
import {
  PopupARModule,
  PopupCustomerModule,
  PopupInvoiceModule,
} from "../modules/ModuleUtil.js";
import { SecurityAccessManager } from "../security/SecurityAccessManager.js";
import { CreditMemoService } from "../services/CreditMemoService";
import { CustomerReturnService } from "../services/CustomerReturnService.js";
import { CustomerService } from "../services/CustomerService.js";
import { InvoiceService } from "../services/InvoiceService";
import { CustomerReturnModuleToolBar } from "../toolBar/CustomerReturnModuleToolBar.js";
import { BaseNodeBar, BaseToolBar, ModuleToolBar } from "./BaseModule.js";
import { ModuleUtils } from "./ModuleUtils.js";
import CustomTable from "../gui_components/CustomTable.js";
import { History,AlignStartVertical} from "lucide-react";
class CustomerReturn extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.cancelReasonDialogRef = React.createRef();
    this.unApproveReasonDialogRef = React.createRef();
    this.state = {
      pageTitle: "Customer Return",
      isShowModuleSearchContainer: true,
      moduleKeyCode: NEW_ENTRY,
      moduleCaption: "CustomerReturn",
      isResetModule: false,
      crData: new CustomerReturnBean(),
      merchandiseLineData: new CustomerReturnMerchandiseLineBean(),
      isShowProgressBarPopup: false,
      progressLoadingText: "",
      isResetView: true,
      customerReturnLookupHandler: null,
      isShowSaveButton: true,
      isShowClearCriteriaButton: false,
      isShowClearErrorButton: true,
      isShowPDFButton: false,
      isShowExcelButton: false,
      isShowApproveButton: true,
      isShowUnApproveButton: false,
      isShowCancelButton: false,
      isShowARModule: false,
      isShowInvoiceModule: false,
      moduleForPopup: [],
      isShowCustomerModule: false,
      isShowCustomerOnOrderInq: false,
      isShowCustomerTransactionsInq: false,
      isShowCustomerStatisticsInq: false,
      isShowCustomerSalesHistoryInq: false,
      isShowCustomerMostRecentFabricsInq: false,
      isCustomerCurrentAgingInq: false,
      isShowFetchInvoicePopup: false,
      invoiceLines: [],
      isShowMerchandiseLinePopup: false,
      isShowInvoiceLookup: false,
      selectedItemList: [],
      isShowMercDelete: false,
      warehouses: [],
      criteria: new CustomerReturnSearchCriteria(),
      currentPageNumber: 0,
      totalCount: 0,
      pageList: new PageListBean(),
      isCustomerReturnListFormOpen: false,
      isCustomerReturnEntryFormOpen: true,
      isCustomerReturnHistoryFormOpened: false,
      custReturnData: [],
      customer_List: [],
      selectedNodeKey: "headerView",
      isShowNodes: false,
      nodeList: [],
      reasonData: new ReasonBean(),
      cancelReasons: [],
      unApproveReasons: [],
      moduleOrderStatus: "",
      disableCRFormFields: false,
      disableCRFetchFields: false,
      isShowGenerateCreditMemoButton: false,
      fetchInvoiceLines: [],
      companyCode: "",
      showAutoCompleteUnApproveReasonList: false,
      unApproveReasonPageListForAutoCompleteList: new Array(),
      showAutoCompleteReasonList: false,
      reasonPageListForAutoCompleteList: new Array(),
      isShowCancelReasonPopup: false,
      isShowUnApproveReasonPopup: false,
      ShowAutoCompleteInvoiceList: false,
      invoicePageListForAutoCompleteList: [],
      disabled: false,
      isShowAutoCompleteCustomerList: false,
      is3PL: false,
      order: "asc",
      sortField: "",
      merchandiseLineList: [],
      statusTrack: [],
      isViewMode: false,
    };
  }
  code = NEW_ENTRY;
  isLocked = false;
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    if (ConfigManager.isPurchaseBasedOnCustomerFlag()) {
      this.state.is3PL = true;
      this.setState({
        is3PL: true,
      });
    }
    this.report_url = appData.reportURL;
    this.initLookupHandlers();
    const { cache } = appData;
    this.cache = cache;
    const attribute_cache = { ...cache };
    // let attribute_cache = JSON.parse(localStorage.getItem("attributeCache"));
    let warehouses = attribute_cache.warehouses;
    let warehouses_temp=[];
    if (warehouses != null || warehouses != undefined) {
      warehouses.map((attr) => {
       warehouses_temp.push(attr);
        this.state.warehouses=ModuleUtils.isActiveAttribute(warehouses_temp);
      });
    }
    let pageInput = new PageListBean();
    pageInput.pageSize = 50;
    let currentPage = this.state.pageList.currentPage;
    if (currentPage == null || currentPage <= 0) {
      pageInput.currentPage = 1;
    } else {
      pageInput.currentPage = currentPage;
    }
    this.state.pageList = pageInput;
    this.state.unApproveReasons = [];
    let unApproveReasons = attribute_cache.invoiceUnApprovalReasons;
    let unApproveReasons_temp=[];
    if (!isEmptyArray(unApproveReasons))
      unApproveReasons.map((ent) => {
       unApproveReasons_temp.push(ent);
        this.state.unApproveReasons=ModuleUtils.isActiveAttribute(unApproveReasons_temp);
      });
    this.state.cancelReasons = [];
    let cancelReasons = attribute_cache.invoiceCancelReasons;
    if (!isEmptyArray(cancelReasons))
      cancelReasons.map((ent) => {
        this.state.cancelReasons.push(ent);
      });
    if (this.props.code !== "" && this.props.code !== undefined) {
      // this.unlockCustomerReturn(this.props.code, false);

      this.code = this.props.code;
      this.editCustomerReturn(this.props.code);
    } else {
      this.addNewEntry();
      //this.loadCustomerReturnPage();
    }
    ModuleUtils.getCustomerReturnStatusList();
  }
  unlockCustomerReturnResponse = (response) => {
    if (!isEmpty(response.data)) {
      if (response.data.isSuccess) {
        if (this.isLocked) {
          this.editCustomerReturn(this.code);
        } else {
          this.isLocked = false;
        }
      } else {
        // this.isLocked = false; optional
        this.showErrorMessage(response.data);
      }
    }
  };
  unlockCustomerReturnError = (error) => {
    ShowError(error);
    // let errList = [];
    // errList.push(error.toString());
    // this.setState({ error_list: errList, isLoading: false });
  };
  unlockCustomerReturn = (code) => {
    let request = new RestEntityUnLockRequest();
    request.companyCode = this.companyCode;
    request.entityCode = code;
    if (SecurityAccessManager.CustomerReturnMaintenance_IsAccessible()) {
      CustomerReturnService.unLockCustomerReturnNumber(
        request,
        this.unlockCustomerReturnResponse,
        this.unlockCustomerReturnError
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  initLookupHandlers = () => {
    let customerReturnLookupHandler = new CustomerReturnLookupHandler(
      this.companyCode,
      "CustomerReturn"
    );
    this.setState({ customerReturnLookupHandler: customerReturnLookupHandler });
    let fabricLookupHandler = new FabricStyleLookupHandler(
      this.companyCode,
      this.state.is3PL ? "Item " : "FabricStyle"
    );
    this.setState({ fabricLookupHandler: fabricLookupHandler });
    let warehouseLookupHandler = new GenericAttributeLookupHandler(
      this.state.warehouses,
      "Warehouse"
    );
    this.setState({ warehouseLookupHandler: warehouseLookupHandler });
  };
  moduleExit = () => {
    let crData = this.state.crData;
    if (crData.code === NEW_ENTRY) {
      this.props.onModuleExit();
    } else {
      if (this.isLocked) {
        this.isLocked = false;
        if (!this.state.isViewMode) this.unlockCustomerReturn(crData.code);
      } else {
        this.isLocked = false;
      }

      this.props.onModuleExit();
    }
  };
  resetView = () => {
    let crData = this.state.crData;
    if (this.isLocked) {
      this.isLocked = false;
      if (!this.state.isViewMode) this.unlockCustomerReturn(crData.code);
    } else {
      this.isLocked = false;
    }

    let cr_Data = new CustomerReturnBean();
    this.setState({
      crData: cr_Data,
      isResetModule: true,
      moduleKeyCode: NEW_ENTRY,
      selectedItemList: [],
      disabled: false,
      merchandiseLineList: [],
      statusTrack: [],
      disableCRFormFields: false,
      disableCRFetchFields: false,
    });
    this.state.moduleKeyCode = NEW_ENTRY;
    this.code = NEW_ENTRY;
    this.state.isViewMode = false;
    this.customerCleared();
    this.hideAlertCallBack();
    this.addNewEntry();
  };

  closeAlertModalCallBack = (isShowPopup) => {
    this.setState({
      isShowUnApprovePopup: isShowPopup,
      isShowAlert: isShowPopup,
      isShowFetchInvoicePopup: isShowPopup,
    });
  };
  hideAlertCallBackLvl3 = (msgType, isDisplayed) => {
    this.setState({ isShowAlertLvl3: isDisplayed });
  };
  resetCustomer = () => {
    let crData = this.state.crData;
    let customer_List = [];
    crData.customerCode = customer_List;
    this.setState({ crData: crData });
  };
  onCustomerCodeChange = (e) => {
    let customerCode = e.target.value;
    this.state.isShowAutoCompleteCustomerList = true;
    let tempData = this.state.crData;
    let showAutoCompleteList = this.state.isShowAutoCompleteCustomerList;
    if (isEmpty(customerCode)) {
      this.state.isShowAutoCompleteCustomerList = false;
      let showAutoCompleteList = this.state.isShowAutoCompleteCustomerList;
      let tempData = this.state.crData;
      tempData.customerCode = "";
      let suggestion = [];
      this.setState({
        isShowAutoCompleteList: showAutoCompleteList,
        crData: tempData,
        customerPageListForAutoCompleteList: suggestion,
      });
      this.customerCleared();
    } else if (
      e.target.name == "customerCode" &&
      showAutoCompleteList === true &&
      customerCode !== ""
    ) {
      setTimeout(() => {
        this.readCustomerBySearchString(e.target.value);
      }, 200);
    }
    tempData[e.target.name] = e.target.value.toUpperCase();
    this.setState({ crData: tempData });
  };
  readCustomerBySearchString(searchString) {
    let searchCriteria = new CustomerSearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.customerCodeStartsWith = searchString;
    searchCriteria.customerNameContains = searchString;
    let cust_pageList = new PageListBean();
    cust_pageList.pageSize = 10;
    let cust_requestInput = new RestCustomerListRequest();
    cust_requestInput.pageInput = cust_pageList;
    cust_requestInput.searchCriteria = searchCriteria;
    CustomerService.getCustomerPageList(
      cust_requestInput,
      this.readCustomerBySearchCodeResponse,
      this.readCustomerBySearchCodeError
    );
  }
  readCustomerBySearchCodeResponse = (response) => {
    let customerData = response.data.customerPageList.customers;
    let simpleAutoCompleteList = new Array();
    if (customerData.length > 0 && customerData != null) {
      customerData.map((customer) => {
        let simpleItemBean = {
          code: customer.code,
          description: customer.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    this.setState({
      customerPageListForAutoCompleteList: simpleAutoCompleteList,
    });
  };
  readCustomerBySearchCodeError = (error) => {
    ShowError("Error : " + error);
  };
  customerCodeEnterKeyEventHandler = (e) => {
    let customerCode = e.target.value;
    this.readCustomerByCustomerCode(customerCode);
    this.state.isShowAutoCompleteCustomerList = false;
    let showAutoCompleteList = this.state.isShowAutoCompleteCustomerList;
    this.setState({
      customerPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteList: showAutoCompleteList,
    });
  };
  displayAutoCustomerCompleteList = (showAutoCompleteList) => {
    this.setState({
      isShowAutoCompleteCustomerList: showAutoCompleteList,
    });
  };

  readCustomerByCustomerCodeResponse = (response) => {
    if (response.data != null && response.data.customer != null) {
      let customerData = response.data.customer;
      let crData = this.state.crData;
      this.setState({
        customerData: customerData,
        crData: crData,
      });
      this.customerSelected();
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  readCustomerByCustomerCodeError = (error) => {
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
    ShowError("Error : " + error);
  };
  readCustomerByCustomerCode = (customerCode) => {
    let readrestInput = new RestReadRequest();
    readrestInput.companyCode = this.companyCode;
    readrestInput.code = customerCode;
    CustomerService.readCustomerWithChildren(
      readrestInput,
      this.readCustomerByCustomerCodeResponse,
      this.readCustomerByCustomerCodeError
    );
  };
  customerCleared() {
    let temp_crData = this.state.crData;
    temp_crData.customerName = "";
    temp_crData.billToCode = "";
    this.setState({
      invoiceLookupHandler: null,
      isShowInvoiceLookup: false,
      crData: temp_crData,
    });
  }
  customerSelected() {
    let temp_crData = this.state.crData;
    let customerData = this.state.customerData;
    temp_crData.customerCode = customerData.code;
    temp_crData.customerName = customerData.description;
    if (!isEmpty(customerData.billTos))
      temp_crData.billToCode = customerData.billTos[0].code;
    if (isEmptyString(temp_crData.billToCode)) temp_crData.billToCode = "B1001";
    this.setState({
      crData: temp_crData,
    });
    let invoiceLookupHandler = new InvoiceLookupHandlers(
      this.companyCode,
      "Invoice",
      this.state.crData.customerCode
    );
    this.setState({
      invoiceLookupHandler: invoiceLookupHandler,
      isShowInvoiceLookup: true,
    });
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  }

  onChange = (e) => {
    let temp_crData = this.state.crData;
    temp_crData[e.target.name] = e.target.value;
    if (e.target.name == "invoiceNumber")
      this.readandValidateInvoice(e.target.value);
    this.setState({ crData: temp_crData });
  };
  readandValidateInvoiceResponse = (response) => {
    let err_msg = "";
    let err_list = [];
    if (response != null) {
      if (response.data.invoice != null) {
        let isValidInvoice = true;
        if (response.data.invoice.invoiceStatus == "X") {
          err_msg =
            "Invalid Invoice!  Invoice# : " +
            this.state.crData.invoiceNumber +
            " is Cancelled ";
          err_list.push(err_msg);
          let crData = this.state.crData;
          crData.invoiceNumber = "";
          this.setState({ crData: crData });
          let invoice = "";
          isValidInvoice = false;
        } else {
          if (!isEmpty(err_msg)) err_list.push(err_msg);
          isValidInvoice = true;
        }
        if (isValidInvoice) {
          this.setState({ invoiceData: response.data.invoice });
        } else {
          this.setState({
            alertMessage: err_list,
            alertType: "danger",
            isShowAlert: true,
          });
        }
      } else {
        err_msg = "Invalid Invoice#!  No Invoice !! ";
        err_list.push(err_msg);
        this.setState({
          alertMessage: err_list,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    }
  };
  readandValidateInvoiceError = (error) => {
    ShowError("Error : " + error);
  };
  readandValidateInvoice = (code) => {
    let readrestInput = new RestReadRequest();
    readrestInput.companyCode = this.companyCode;
    readrestInput.code = code;
    InvoiceService.readInvoice(
      readrestInput,
      this.readandValidateInvoiceResponse,
      this.readandValidateInvoiceError
    );
  };
  openMerchandiseLineDetailDialog = () => {
    this.setState({ isShowMerchandiseLinePopup: true });
  };
  closeMerchandiseLineAlertModalCallBack = (isShowPopup) => {
    isShowPopup = false;
    this.setState({
      isShowMerchandiseLinePopup: isShowPopup,
    });
  };
  setAndShowInvoiceLines = (merchandiseLines, invoiceLines) => {
    merchandiseLines.map((merc, j) => {
      invoiceLines.map((inv, i) => {
        if (
          merc.fabricStyleCode == inv.fabricStyleCode &&
          merc.colorCode == inv.colorCode
        ) {
          invoiceLines.splice(i, 1);
        }
      });
    });
    this.setState({
      invoiceLines: invoiceLines,
      isShowFetchInvoicePopup: true,
      selectedItemList: [],
    });
  };
  onFetchInvoiceClickResponse = (response) => {
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Loading Popup...",
    });
    let err_msg = "";
    let err_list = [];
    if (response.data.resultBean != null) {
      if (response.data.resultBean.invoiceRollLinesWithPrice != null) {
        let invLines = response.data.resultBean.invoiceRollLinesWithPrice;
        this.setState({ invoiceLines: invLines });
        this.setState({
          fetchInvoiceLines: invLines,
        });
        if (invLines != null && invLines.length > 0) {
          let crData = this.state.crData;
          if (!isEmptyArray(crData.merchandiseLines)) {
            this.setAndShowInvoiceLines(crData.merchandiseLines, invLines);
          } else {
            this.setState({
              isShowFetchInvoicePopup: true,
              selectedItemList: [],
            });
          }
          this.setState({
            isShowProgressBarPopup: false,
            progressLoadingText: "",
          });
        } else {
          err_msg = "No Invoice !! ";
          err_list.push(err_msg);

          this.setState({
            alertMessage: err_list,
            alertType: "danger",
            isShowAlert: true,
          });
          this.setState({
            isShowProgressBarPopup: false,
            progressLoadingText: "",
          });
        }
      }
    } else {
      err_msg = "Invalid Invoice#!  No Invoice !! ";
      err_list.push(err_msg);
      this.setState({
        alertMessage: err_list,
        alertType: "danger",
        isShowAlert: true,
      });
      this.setState({
        isShowProgressBarPopup: false,
        progressLoadingText: "",
      });
    }
  };
  onFetchInvoiceClickError = (error) => {
    ShowError("Error : " + error);
  };
  fetchInvoiceOnClick = () => {
    let customerReturnBean = new CustomerReturnBean();
    customerReturnBean.companyCode = this.companyCode;
    customerReturnBean.invoiceNumber = this.state.crData.invoiceNumber;
    if (SecurityAccessManager.CustomerReturnMaintenance_IsAccessible()) {
      CreditMemoService.getRollLinesForInvoiceNumbers(
        customerReturnBean,
        this.onFetchInvoiceClickResponse,
        this.onFetchInvoiceClickError
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  selectAllItem = (e) => {
    if (e.detail === 1) {
      let list = this.state.invoiceLines;
      list.map((line) => {
        line.isActive = true;
      });
      this.setState({ selectedItemList: list });
    }
  };
  unSelectAllItem = (e) => {
    if (e.detail === 1) {
      let list = this.state.invoiceLines;
      list.map((line) => {
        line.isActive = false;
      });
      this.setState({ selectedItemList: [] });
    }
  };
  invCheck = (e, rowData) => {
    let selectedItemList = this.state.selectedItemList;
    rowData.isActive = e.target.value;
    if (rowData.isActive === true) {
      selectedItemList.push(rowData);
      this.setState({ selectedItemList: selectedItemList });
    } else {
      let selectedItemList = this.state.selectedItemList;

      let invList = [];
      for (let item of selectedItemList) {
        if (item.isActive != rowData.isActive) {
          invList.push(item);
          // this.setState({ selectedItemList: invList });
        }
      }
      this.setState({ selectedItemList: invList });
      this.state.selectedItemList = invList;
    }
  };
  customerReturnColumns = () => {
    const columns = new Array();
    columns.push(
      new ColumnDefinition()
        .setDetails("", "isActive", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
        .setInputDetails(false, false, true, null, this.invCheck, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails(
          this.state.is3PL ? "Item" : "FabricStyle#",
          "fabricStyleCode",
          true
        )
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
      // .setClickDetails(true, false, this.viewInvoiceModule,null )
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("Name#", "fabricStyleName", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Color", "colorCode", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails(
          this.state.is3PL ? "Inventory#" : "RollSKU#",
          "rollSkuNumber",
          true
        )
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Box#", "boxNumber", true)
        .setStyleDetails("right", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Roll#", "rollNumber", true)
        .setStyleDetails("right", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Price", "price", true)
        .setStyleDetails("right", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Shipped Qty#", "shippedQuantity", true)
        .setStyleDetails("right", "", "", "wt-3", "wt-3")
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("Vendor Lot#", "vendorBatchNumber", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );
    return columns;
  };
  columnDefinitions = () => {
    let columnList = [];
    columnList.push(
      new DataGridColumnDefinition()
        .setDetails(
          "",
          "isActive",
          0,
          false, //set hyperlink false
          null, //set hyperLink call back null
          false,
          null
        )
        .setEditableDetails(false, "", null, false, null, true, this.invCheck)
    );

    columnList.push(
      new DataGridColumnDefinition().setDetails(
        this.state.is3PL ? "Item" : "FabricStyle#",
        "fabricStyleCode"
      )
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "Name#",
        "fabricStyleName",
        0,
        false,
        null,
        false,
        null,
        "1rem",
        "20rem"
      )
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "Color",
        "colorCode",
        0,
        false,
        null,
        false,
        null
      )
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        this.state.is3PL ? "Inventory#" : "RollSKU#",
        "rollSkuNumber",
        0,
        false,
        null,
        false,
        null
      )
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "Box#",
        "boxNumber",
        0,
        false,
        null,
        false,
        null
      )
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "Roll#",
        "rollNumber",
        0,
        false,
        null,
        false,
        null
      )
    );

    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "Price",
        "price",
        1,
        false,
        null,
        false,
        null
      )
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "Shipped Qty#",
        "shippedQuantity",
        1,
        false,
        null,
        false,
        null
      )
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "Vendor Lot#",
        "vendorBatchNumber",
        0,
        false,
        null,
        false,
        null
      )
    );
    return columnList;
  };

  getSelectedInvoiceLineMaxNumber() {
    let maxLineNumber = 0;
    let invLineFormData = this.state.crData.merchandiseLines;
    if (invLineFormData.length > 0)
      invLineFormData.map((line) => {
        if (line.lineNumber > maxLineNumber) {
          maxLineNumber = line.lineNumber;
        }
      });
    return maxLineNumber;
  }
  addInvoiceLinesToReturn = (e) => {
    if (e.detail === 1) {
      let selectedInvoiceLines = this.state.selectedItemList;
      let lines = this.state.invoiceLines;
      if (!selectedInvoiceLines) return;
      let invoiceLines = new Array();
      invoiceLines = selectedInvoiceLines;
      let tempCrData = this.state.crData;
      let tempMerchandiseData = [];
      let lineNumber = this.getSelectedInvoiceLineMaxNumber();
      invoiceLines.map((line) => {
        let merchandiseLine = new CustomerReturnMerchandiseLineBean();
        merchandiseLine.companyCode = line.companyCode;
        merchandiseLine.fabricStyleCode = line.fabricStyleCode;
        merchandiseLine.fabricStyleName = line.fabricStyleName;
        merchandiseLine.colorCode = line.colorCode;
        merchandiseLine.lineNumber = ++lineNumber;
        merchandiseLine.widthCode = line.widthCode;
        merchandiseLine.locationCode = line.locationCode;
        merchandiseLine.price = line.price;
        merchandiseLine.skuNumber = line.skuNumber;
        merchandiseLine.rollNumber = line.rollNumber;
        merchandiseLine.rollSkuNumber = line.rollSkuNumber;
        merchandiseLine.uomCode = line.invoiceUomCode;
        merchandiseLine.currencyCode = "USD";
        merchandiseLine.invoiceNumber = line.invoiceNumber;
        merchandiseLine.isSelected = false;
        merchandiseLine.lineStatus = "O";
        merchandiseLine.lineTotalReturnQuantity = line.shippedQuantity;
        merchandiseLine.lineTotalAmount =
          parseFloat(merchandiseLine.lineTotalReturnQuantity) *
          parseFloat(merchandiseLine.price);
        tempCrData.merchandiseLines.push(merchandiseLine);
      });
      tempMerchandiseData = tempCrData.merchandiseLines;
      this.setState({
        crData: tempCrData,
        invoiceLines: lines,
        merchandiseLineList: tempMerchandiseData,
      });
      this.closeAlertModalCallBack(false);
      this.calculateTotals();
    }
  };
  deleteMerchandiseLine = (rowData) => {
    let fetchInvoiceLines = this.state.fetchInvoiceLines;
    let invoiceLines = this.state.invoiceLines;
    let crData = this.state.crData;
    let mercLines = crData.merchandiseLines;
    if (!rowData.isFetched) {
      fetchInvoiceLines.map((inv) => {
        if (
          rowData.fabricStyleCode == inv.fabricStyleCode &&
          rowData.colorCode == inv.colorCode
        ) {
          invoiceLines.push(inv);
        }
      });
      var index = mercLines.indexOf(rowData);
      if (index > -1) {
        mercLines.splice(index, 1);
      }
      this.reArrangeMercLineNumbers(mercLines);
      this.setState({ crData: crData, invoiceLines: invoiceLines });
      this.calculateTotals();
    }
  };
  reArrangeMercLineNumbers = (lineList) => {
    let itemList = [];
    if (!isEmpty(lineList)) {
      let maxLineNumber = 0;
      lineList.map((line) => {
        ++maxLineNumber;
        line.lineNumber = maxLineNumber;
      });
      this.setState({ selectedItemList: itemList });
    } else {
      this.setState({ selectedItemList: itemList });
    }
  };
  getMerchandiseLineDetails = (merchandiseLineData) => {
    let temp_MerchandiseLineData = new CustomerReturnMerchandiseLineBean();
    let crData = this.state.crData;
    temp_MerchandiseLineData = { ...merchandiseLineData };
    temp_MerchandiseLineData.currencyCode = crData.customerCurrencyCode;
    temp_MerchandiseLineData.creditMemoNumber = crData.code;
    temp_MerchandiseLineData.companyCode = crData.companyCode;
    this.setState({ merchandiseLineData: temp_MerchandiseLineData });
  };
  onMerchandiseChange = (e) => {
    let temp_merchandiseLineData = this.state.merchandiseLineData;
    temp_merchandiseLineData[e.target.name] = e.target.value;
    if (e.target.name == "price") {
      let lineTotalAmount = 0;
      lineTotalAmount =
        this.state.merchandiseLineData.lineTotalReturnQuantity * e.target.value;
      temp_merchandiseLineData["lineTotalAmount"] = lineTotalAmount;
    } else if (e.target.name == "lineTotalReturnQuantity") {
      let lineTotalAmount = 0;
      lineTotalAmount = this.state.merchandiseLineData.price * e.target.value;
      temp_merchandiseLineData["lineTotalAmount"] = lineTotalAmount;
    }
    this.setState({ merchandiseLineData: temp_merchandiseLineData });
  };
  locationOnChange = (e) => {
    let locationCode = e.target.value;
    this.state.isShowAutoCompleteLocationList = true;
    let tempData = this.state.merchandiseLineData;
    let showAutoCompleteList = this.state.isShowAutoCompleteLocationList;
    if (isEmpty(locationCode)) {
      this.state.isShowAutoCompleteLocationList = false;
      let showAutoCompleteList = this.state.isShowAutoCompleteLocationList;
      let tempData = this.state.merchandiseLineData;
      tempData.locationCode = "";
      let suggestion = [];
      this.setState({
        isShowAutoCompleteList: showAutoCompleteList,
        merchandiseLineData: tempData,
        locationPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "locationCode" &&
      showAutoCompleteList === true &&
      locationCode !== ""
    ) {
      this.readLocationBySearchString(e.target.value);
      this.readLocation(e.target.value);
    }
    tempData[e.target.name] = e.target.value.toUpperCase();
    this.setState({ merchandiseLineData: tempData });
  };
  locationEnterKeyEvent = (e) => {
    this.readLocation(e.target.value);
    this.state.isShowAutoCompleteLocationList = false;
    let showAutoCompleteList = this.state.isShowAutoCompleteLocationList;
    this.setState({
      locationPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteList: showAutoCompleteList,
    });
  };
  displayLocationAutoCompleteList = (isShowAutoCompleteList) => {
    this.setState({
      isShowAutoCompleteLocationList: isShowAutoCompleteList,
    });
  };
  readLocationBySearchString = (searchString) => {
    let locationData = this.state.warehouses;
    let simpleAutoCompleteList = new Array();
    if (locationData.length > 0 && locationData != null) {
      locationData.map((obj) => {
        let locationBean = {
          code: obj.code,
          description: obj.description,
        };
        simpleAutoCompleteList.push(locationBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (list) => list.code.toLowerCase().indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({
      locationPageListForAutoCompleteList: filteredSuggestions,
    });
  };
  readLocation = (locationCode) => {
    let tempData = this.state.merchandiseLineData;
    let locationBean = null;
    let locationData = null;
    this.state.warehouses.map((ln) => {
      if (ln.code === locationCode) {
        locationBean = ln;
        locationData = new BaseBean();
        locationData.code = ln.code;
        locationData.description = ln.description;
      }
    });
    if (!isEmpty(locationBean)) {
      tempData.locationCode = locationBean.code;
      this.state.isShowAutoCompleteLocationList = false;
      let showAutoCompleteList = this.state.isShowAutoCompleteLocationList;
      this.setState({
        merchandiseLineData: tempData,
        isShowAutoCompleteLocationList: showAutoCompleteList,
      });
    }
  };
  validateMerchandiseLine = () => {
    let isValidMerchandiseLine = false;
    let err_list = [];
    let errorMessage = "";
    let temp_merchandiseLineData = this.state.merchandiseLineData;
    if (temp_merchandiseLineData == null) {
      let errMsg = "Invalid data ";
      errorMessage = errorMessage + errMsg;
      err_list.push(errMsg);
    } else {
      isValidMerchandiseLine = true;
    }
    return isValidMerchandiseLine;
  };
  getMerchandiseLine = (lineNumber) => {
    let merchandiseLine = null;
    if (isEmpty(this.state.crData)) return merchandiseLine;
    else if (isEmptyArray(this.state.crData.merchandiseLines))
      return merchandiseLine;
    else {
      this.state.crData.merchandiseLines.map((line) => {
        if (line.lineNumber === lineNumber) {
          merchandiseLine = line;
          return merchandiseLine;
        }
      });
    }
    return merchandiseLine;
  };

  getInvoiceLineMaxLineNumber() {
    let maxLineNumber = 0;
    let invLineFormData = this.state.crData.merchandiseLines;
    if (invLineFormData.length > 0)
      invLineFormData.map((line) => {
        if (line.lineNumber > maxLineNumber) {
          maxLineNumber = line.lineNumber;
        }
      });
    return maxLineNumber;
  }

  addorUpdateMerchandiseLine = (e) => {
    if (e.detail === 1) {
      let crData = this.state.crData;
      let invoiceLines = crData.merchandiseLines;
      let merchandiseLineData = this.state.merchandiseLineData;
      let isValidLine = false;
      isValidLine = this.validateMerchandiseLine();
      if (isValidLine) {
        var lineNumber = this.getInvoiceLineMaxLineNumber();
        let isLineFound = false;
        if (!isEmptyArray(invoiceLines)) {
          invoiceLines.map((line, lineNumber) => {
            if (line.lineNumber == merchandiseLineData.lineNumber) {
              invoiceLines[lineNumber] = merchandiseLineData;
              isLineFound = true;
            }
          });
        }

        this.setState({
          crData: crData,
          merchandiseLineData: new CustomerReturnMerchandiseLineBean(),
        });
        this.closeMerchandiseLineAlertModalCallBack(false);
        this.calculateTotals();
      }
    }
  };
  calculateTotals() {
    if (!isEmpty(this.state.crData)) {
      let totMerchandiseAmount = 0;
      if (!isEmptyArray(this.state.crData.merchandiseLines)) {
        this.state.crData.merchandiseLines.map((line) => {
          totMerchandiseAmount =
            totMerchandiseAmount + parseFloat(line.lineTotalAmount);
        });
      }
      this.state.crData.totalReturnAmount = parseFloat(totMerchandiseAmount);
    }
  }
  clearMerchandiseLineValues = (e) => {
    if (e.detail === 1) {
      let temp_MerchandiseLineData = new CustomerReturnMerchandiseLineBean();
      this.setState({
        merchandiseLineData: temp_MerchandiseLineData,
      });
    }
  };
  listFormOnChange = (e) => {
    let criteria = this.state.criteria;
    criteria["customerReturnNumberContains"] = e.target.value;
    this.setState({ criteria: criteria });
  };
  resetFilter = () => {
    let criteria = new CustomerReturnSearchCriteria();
    criteria.companyCode = this.companyCode;
    this.state.criteria = criteria;
    this.setState({ criteria: criteria });
    this.loadPage(1);
  };
  loadFirst = () => {
    this.loadPage(1);
  };
  loadPrevious = () => {
    let currentPage = this.state.pageList.currentPage;
    let previousPage = currentPage - 1;
    this.loadPage(previousPage);
  };
  loadNext = () => {
    let currentPage = this.state.pageList.currentPage;
    let nextPage = currentPage + 1;
    this.loadPage(nextPage);
  };
  loadLast = () => {
    let pageSize = this.state.pageList.pageSize;
    let totalCount = this.state.pageList.totalCount;
    let totalPages = totalCount / pageSize;
    totalPages += totalCount % pageSize == 0 ? 0 : 1;
    this.loadPage(totalPages);
  };
  filter = () => {
    this.loadPage(1);
  };
  resetFilteredCR = () => {
    let criteria = new CustomerReturnSearchCriteria();
    criteria.companyCode = this.companyCode;
    this.state.criteria = criteria;
    this.setState({ criteria: criteria });
    this.loadPage(1);
  };

  loadCustomerReturnPage = () => {
    let criteria = new CustomerReturnSearchCriteria();
    criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    let pageList = new PageListBean();
    pageList = this.state.pageList;
    let cust_requestInput = new RestCustomerReturnListRequest();
    cust_requestInput.pageInput = pageList;
    cust_requestInput.searchCriteria = criteria;
    if (SecurityAccessManager.CustomerReturnView_IsAccessible()) {
      CustomerReturnService.getCustomerReturnPageList(
        cust_requestInput,
        this.loadCustomerReturnResponse,
        this.loadCustomerError
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  validateCustomerReturnData = (crData) => {
    let isValidData = false;
    let err_list = [];
    let errorMessage = "";
    if (crData == null) {
      let errMsg = "Invalid data ";
      errorMessage = errorMessage + errMsg;
      err_list.push(errMsg);
    } else {
      if (isEmptyString(crData.customerCode)) {
        let errMsg = "CustomerCode is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (isEmptyString(crData.customerName)) {
        let errMsg = "CustomerName is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (isEmpty(crData.totalReturnAmount)) {
        let errMsg = "No Customer Return Amount Desc";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (isEmpty(crData.merchandiseLines)) {
        let errMsg = "MerchandiseLines is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
    }
    if (err_list.length > 0) {
      isValidData = false;
      this.setState({
        alertMessage: err_list,
        alertType: "danger",
        isShowAlert: true,
      });
    } else {
      isValidData = true;
    }
    return isValidData;
  };
  handleResponse = (response) => {
    let success = false;
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
      this.setState({
        isShowProgressBarPopup: false,
        progressLoadingText: "",
      });
      success = false;
    }
    if (response.infos != null) {
      let infoMsg = "";
      let successMsg = [];
      response.infos.map(
        (info) => (infoMsg = infoMsg + info.messageDescription)
      );
      successMsg.push(infoMsg);
      this.setState({
        alertMessage: successMsg,
        alertType: "success",
        isShowAlert: true,
      });
      success = true;
    }
    return success;
  };
  saveCustomerReturnResponse = (response) => {
    let isSuccess = this.handleResponse(response.data);
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Loading...",
    });
    if (
      response.data !== null &&
      response.data.customerReturn !== null &&
      isSuccess
    ) {
      let cr = response.data.customerReturn;
      let pageTitle = this.state.moduleCaption + " - EDIT";
      this.setState({
        crData: cr,
        pageTitle: pageTitle,
      });
      this.setState({
        isShowProgressBarPopup: false,
        progressLoadingText: "",
      });

      // this.unlockCustomerReturn(cr.code, false);
      // this.editCustomerReturn(cr.code);
      if (!this.isLocked) {
        this.editCustomerReturn(cr.code);
      } else {
        this.code = cr.code;
        this.unlockCustomerReturn(cr.code);
      }
    }
  };

  saveCustomerReturnError = (error) => {
    ShowError("Error : " + error);
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  clearError = () => {
    this.setState({ error_list: [] });
  };
  save = () => {
    this.saveCustomerReturn();
  };
  saveCustomerReturn = () => {
    let crData = this.state.crData;
    crData.companyCurrencyCode = "USD";
    crData.companyCode = this.companyCode;
    crData.customerCurrencyCode = "USD";
    let isValid = false;
    isValid = this.validateCustomerReturnData(crData);
    if (isValid) {
      if (crData.isFetched) {
        if (SecurityAccessManager.CustomerReturnUpdation_IsAccessible()) {
          CustomerReturnService.updateCustomerReturn(
            crData,
            this.saveCustomerReturnResponse,
            this.saveCustomerReturnError
          );
        } else {
          let errMsg = "Access Denied";
          let errList = [];
          errList.push(errMsg);
          this.setState({
            alertMessage: errList,
            alertType: "danger",
            isShowAlert: true,
          });
        }
      } else {
        if (SecurityAccessManager.CustomerReturnCreation_IsAccessible()) {
          CustomerReturnService.createCustomerReturn(
            crData,
            this.saveCustomerReturnResponse,
            this.saveCustomerReturnError
          );
        } else {
          let errMsg = "Access Denied";
          let errList = [];
          errList.push(errMsg);
          this.setState({
            alertMessage: errList,
            alertType: "danger",
            isShowAlert: true,
          });
        }
      }
    }
  };
  loadCustomerReturnResponse = (response) => {
    let custReturnData = new Array();
    let pageList = this.state.pageList;
    if (response.data.customerReturnPageList != null) {
      custReturnData = response.data.customerReturnPageList.customerReturns;
      pageList.totalCount = response.data.customerReturnPageList.totalCount;
      pageList.currentPage = response.data.customerReturnPageList.currentPage;
    } else {
      custReturnData = new Array();
    }

    this.setState({
      custReturnData: custReturnData,
      pageList: pageList,
    });
  };

  loadCustomerError = (error) => {};
  loadPage = (pageNumber) => {
    let criteria = new CustomerReturnSearchCriteria();
    criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    this.state.criteria = criteria;
    let pageInput = new RestPageListBean();
    pageInput.pageSize = 50;
    pageInput.currentPage = pageNumber;
    this.state.pageList = pageInput;
    this.loadCustomerReturnPage();
  };
  getModuleListView = () => {
    let crData = this.state.crData;
    if (crData.code === NEW_ENTRY) {
      this.closeEntryForm();
      this.loadCustomerReturnPage();
    } else {
      if (this.isLocked) {
        this.isLocked = false;
        if (!this.state.isViewMode) this.unlockCustomerReturn(crData.code);
      } else {
        this.isLocked = false;
      }

      this.closeEntryForm();
      this.loadCustomerReturnPage();
    }
  };
  moduleCaption = "Customer Return";
  closeEntryForm = () => {
    let pageTitle = this.moduleCaption;
    this.setState({
      isCustomerReturnListFormOpen: true,
      isCustomerReturnEntryFormOpen: false,
      isShowNewButton: false,
      isShowSaveButton: false,
      isShowClearCriteriaButton: false,
      isShowClearErrorButton: false,
      isShowPDFButton: false,
      isShowExcelButton: false,
      isShowApproveButton: false,
      isShowLoadCustomerReturnButton: false,
      isShowAdjustButton: false,
      isShowBackButton: false,
      isShowApprovePrintButton: false,
      isShowCancelButton: false,
      pageTitle: pageTitle,
      error_list: [],
      isShowModuleSearchContainer: false,
      moduleKeyCode: NEW_ENTRY,
      disabled: false,
      isResetView: false,
      isShowNodes: false,
      disableCRFormFields: false,
      disableCRFetchFields: false,
      isViewMode: false,
    });
  };
  addNewEntry = () => {
    let newCustomerReturn = new CustomerReturnBean();
    newCustomerReturn.companyCode = this.companyCode;
    newCustomerReturn.code = NEW_ENTRY;
    let pageTitle = this.state.moduleCaption + " - NEW";
    newCustomerReturn.customerReturnStatus =
      LogicConstants.CUSTOMER_RETURN_OPEN_STATUS;
    let date = new Date();
    let currentDate = date.toLocaleDateString("sv-SE");
    newCustomerReturn.customerReturnDate = currentDate;
    newCustomerReturn.createdDate = currentDate;

    if (!isEmptyString(this.state.moduleKeyCode)) {
      newCustomerReturn.code = this.state.moduleKeyCode;
      if (this.state.moduleKeyCode == NEW_ENTRY) {
        this.isLocked = false;
      } else {
        this.isLocked = true;
      }
    } else newCustomerReturn.code = NEW_ENTRY;

    this.setState({
      crData: newCustomerReturn,
      pageTitle: pageTitle,

      isShowSaveButton: true,
      merchandiseLineList: [],
      statusTrack: [],
    });
    this.state.isDisableFields = false;
    this.state.isCollapsible_open = true;
    this.state.crData = newCustomerReturn;
    this.openEntryForm();
  };
  openEntryForm = () => {
    let crData = this.state.crData;
    this.closeAllNodeViews();
    this.getNodeList();
    this.setState({
      isCustomerReturnEntryFormOpen: true,
      isCustomerReturnListFormOpen: false,
      isShowSaveButton: true,
      isShowClearCriteriaButton: false,
      isShowClearErrorButton: true,
      isShowPDFButton: false,
      isShowExcelButton: false,
      merchandiseLineData: new CustomerReturnMerchandiseLineBean(),
      isShowModuleSearchContainer: true,
      isResetView: true,
      isShowNodes: true,
      isShowAutoCompleteLocationList: false,
      locationPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteCustomerList: false,
      customerPageListForAutoCompleteList: new Array(),
      disabled: false,
    });
    if (this.state.moduleKeyCode != NEW_ENTRY) {
      this.setState({ disabled: true });
    }
    let moduleOrderStatus = this.state.moduleOrderStatus;
    let status = ModuleUtils.getCustomerReturnStatusCaption(
      crData.CustomerReturnStatus
    );
    if (!crData.isFetched) {
      this.setState({
        isShowMercDelete: true,
      });
    }
    if (crData.isFetched) {
      this.setState({
        isShowMercDelete: false,
      });
    }
    if (status !== undefined && status !== null) {
      moduleOrderStatus = status;
    }
    this.setState({ moduleOrderStatus: moduleOrderStatus });
    if (
      crData.customerReturnStatus ==
      LogicConstants.CUSTOMER_RETURN_UNAPPROVE_STATUS
    ) {
      this.setState({
        isShowApproveButton: true,
        isShowApprovePrintButton: true,
        isShowCancelButton: false,
        isShowSaveButton: true,
        disableCRFormFields: false,
        isShowUnApproveButton: false,
      });
    } else if (
      crData.customerReturnStatus == LogicConstants.CUSTOMER_RETURN_OPEN_STATUS
    ) {
      if (crData.isFetched) {
        this.setState({
          isShowApprovePrintButton: true,
          isShowSaveButton: true,
          isShowApproveButton: true,
          disableCRFormFields: false,
          isShowCancelButton: true,
          isShowSaveButton: true,
          isShowUnApproveButton: false,
          isShowGenerateCreditMemoButton: false,
        });
      } else {
        this.setState({
          isShowCancelButton: false,
          isShowSaveButton: true,
          isShowApproveButton: true,
          disableCRFormFields: false,
          isShowUnApproveButton: false,
          isShowGenerateCreditMemoButton: false,
        });
      }
    } else if (
      crData.customerReturnStatus ==
      LogicConstants.CUSTOMER_RETURN_CANCEL_STATUS
    ) {
      this.setState({
        isShowCancelButton: false,
        isShowSaveButton: false,
        isShowApproveButton: false,
        isShowUnApproveButton: false,
        disableCRFormFields: true,
        disableCRFetchFields: true,
        isShowFetchInvoicePopup: false,
        isShowGenerateCreditMemoButton: false,
      });
    } else if (
      crData.customerReturnStatus ==
      LogicConstants.CUSTOMER_RETURN_APPROVE_STATUS
    ) {
      this.setState({
        isShowCancelButton: true,
        isShowSaveButton: true,
        isShowApproveButton: false,
        isShowUnApproveButton: true,
        disableCRFormFields: true,
        disableCRFetchFields: false,
        isShowGenerateCreditMemoButton: true,
      });
    }
    if (this.state.isViewMode) {
      let pageTitle = this.moduleCaption + " - VIEW";
      this.setState({
        disableCRFormFields: true,
        disableCRFetchFields: true,
        disabled: true,
        pageTitle: pageTitle,
      });
    }
  };
  showErrorMessage = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  editCustomerReturnResponse = (response) => {
    let errMsg = "";
    let statusTrack = [];
    if (response.data.lockResponse != null) {
      if (!isEmpty(response.data.lockResponse.errors)) {
        this.showErrorMessage(response.data.lockResponse);
        this.state.isViewMode = true;
      }
    }
    if (response.data.customerReturnResponse != null) {
      if (response.data.customerReturnResponse.errors != null) {
        response.data.customerReturnResponse.errors.map((err) => {
          errMsg = err.messageDescription;
        });
      }
    }
    if (response.data.customerReturnResponse != null) {
      if (
        errMsg !=
        "CustomerReturn [" + this.state.moduleKeyCode + "] Not read!"
      ) {
        this.showErrorMessage(response.data.customerReturnResponse);
      }
    }
    if (response.data.dependenciesResponse != null) {
      if (response.data.dependenciesResponse.dependenciesBean != null) {
      }
    }
    if (response.data != null) {
      if (response.data.customerReturnResponse != null) {
        if (response.data.customerReturnResponse.customerReturn != null) {
          const cr = response.data.customerReturnResponse.customerReturn;
          let moduleKeyCode = cr.code;
          let pageTitle = this.moduleCaption + " - EDIT";
          statusTrack = cr.statusTracks;
          this.setState({
            crData: cr,
            pageTitle: pageTitle,
            moduleKeyCode: moduleKeyCode,
            statusTrack: statusTrack,
          });
          this.state.crData = cr;
          this.isLocked = true;
          this.openEntryForm();
        } else {
          this.addNewEntry();
        }
      }
    }
  };

  editCustomerReturnError = (error) => {
    this.showErrorMessage("Error : " + error);
  };
  editCustomerReturn = (crNumber) => {
    let readrestInput = new RestReadRequest();
    readrestInput.companyCode = this.companyCode;
    readrestInput.code = crNumber;
    let isLockRequired = NEW_ENTRY === crNumber ? false : true;
    readrestInput.isLockRequired = isLockRequired;
    if (SecurityAccessManager.CustomerReturnView_IsAccessible()) {
      CustomerReturnService.initCustomerReturnModule(
        readrestInput,
        this.editCustomerReturnResponse,
        this.editCustomerReturnError
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  approveCustomerReturnResponse = (response) => {
    let isSuccess = this.handleApproveResponse(response.data);
    if (
      !isEmpty(response.data) &&
      !isEmpty(response.data.mainOperationResponse) &&
      !isEmpty(response.data.mainOperationResponse.customerReturn) &&
      isSuccess
    ) {
      let cr = response.data.mainOperationResponse.customerReturn;
      if (!isEmpty(cr)) {
        let pageTitle = this.moduleCaption + " - EDIT";
        this.setState({
          crData: cr,
          pageTitle: pageTitle,
        });
        // this.unlockCustomerReturn(cr.code);
        // this.editCustomerReturn(cr.code);

        if (!this.isLocked) {
          this.editCustomerReturn(cr.code);
        } else {
          this.code = cr.code;
          this.unlockCustomerReturn(cr.code);
        }
      }
    }
  };
  approveCustomerReturnError = (error) => {
    ShowError("Error : " + error);
  };
  approveCustomerReturn = () => {
    let crData = this.state.crData;
    crData.companyCurrencyCode = "USD";
    crData.companyCode = this.companyCode;
    crData.customerCurrencyCode = "USD";
    let request = new RestCustomerReturnBeanRequest();
    request.customerReturnBean = crData;
    request.companyCode = this.companyCode;
    let isValid = false;
    isValid = this.validateCustomerReturnData(this.state.crData);
    if (isValid) {
      if (crData.isFetched) {
        if (
          SecurityAccessManager.CustomerReturnApproval_IsAccessible() &&
          SecurityAccessManager.CustomerReturnUpdation_IsAccessible()
        ) {
          CustomerReturnService.updateAndApproveCustomerReturn(
            request,
            this.approveCustomerReturnResponse,
            this.approveCustomerReturnError
          );
        } else {
          let errMsg = "Access Denied";
          let errList = [];
          errList.push(errMsg);

          this.setState({
            alertMessage: errList,
            alertType: "danger",
            isShowAlert: true,
          });
        }
      } else if (
        SecurityAccessManager.CustomerReturnCreation_IsAccessible() &&
        SecurityAccessManager.CustomerReturnUpdation_IsAccessible()
      ) {
        CustomerReturnService.createAndApproveCustomerReturn(
          request,
          this.approveCustomerReturnResponse,
          this.approveCustomerReturnError
        );
      } else {
        let errMsg = "Access Denied";
        let errList = [];
        errList.push(errMsg);

        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    }
  };
  handleApproveResponse = (response) => {
    let success = false;
    let mainResponseSuccess = false;
    let additionalResponseSuccess = false;
    let errMsg = "";
    let infoMsg = "";
    let errList = [];
    if (response.mainOperationResponse != null) {
      if (response.mainOperationResponse.errors != null) {
        response.mainOperationResponse.errors.map(
          (err) => (
            (errMsg = errMsg + "\n" + err.messageDescription),
            errList.push(err.messageDescription)
          )
        );
        mainResponseSuccess = false;
      }
      if (response.mainOperationResponse.infos != null) {
        response.mainOperationResponse.infos.map(
          (info) => (infoMsg = infoMsg + "\n" + info.messageDescription)
        );
        mainResponseSuccess = true;
      }
    }
    if (response.additionalOperationResponse != null) {
      if (response.additionalOperationResponse.errors != null) {
        response.additionalOperationResponse.errors.map(
          (err) => (
            (errMsg = errMsg + "\n" + err.messageDescription),
            errList.push(err.messageDescription)
          )
        );
        additionalResponseSuccess = false;
      }
      if (response.additionalOperationResponse.infos != null) {
        response.additionalOperationResponse.infos.map(
          (info) => (infoMsg = infoMsg + "\n" + info.messageDescription)
        );
        additionalResponseSuccess = true;
      }
    }
    let successMsg = [];
    successMsg.push(infoMsg);
    this.setState({
      alertMessage: successMsg,
      alertType: "success",
      isShowAlert: true,
    });
    this.setState({ error_list: errList });
    success = mainResponseSuccess && additionalResponseSuccess;
    return success;
  };
  onModuleKeyCodeChange = (e) => {
    let moduleKeyCode = this.state.moduleKeyCode;
    if (e.target.value !== NEW_ENTRY && e.target.value !== "undefined") {
      moduleKeyCode = e.target.value;
    }
    this.setState({ moduleKeyCode: moduleKeyCode });
  };
  onModuleKeyCodeWithCriteriaOnChange = (e) => {
    let moduleKeyCode = this.state.moduleKeyCode;
    if (e.target.value !== NEW_ENTRY && e.target.value !== "undefined") {
      moduleKeyCode = e.target.value.toUpperCase();
    }
    this.setState({ moduleKeyCode: moduleKeyCode });
    let crData = this.state.crData;
  };
  selectButtonClick = (e) => {
    this.editCustomerReturn(this.state.moduleKeyCode);
    // this.disable();
  };
  disable = () => {
    this.setState({
      disabled: true,
    });
  };
  closeAllNodeViews = () => {
    this.setState({
      isShowSaveButton: false,
      isCustomerReturnListFormOpen: false,
      isCustomerReturnEntryFormOpen: false,
      isCustomerReturnHistoryFormOpened: false,
    });
  };
  getEmptyView() {
    return <div></div>;
  }
  getNodeList = () => {
    let nodeList = [];
    let crData = this.state.crData;
    let headerObject = this.getEmptyView();
    let historyObject = this.getEmptyView();
    let headerNode = new NodeData("headerView", "Header", headerObject,<AlignStartVertical size={16} />);
    let historyNode = new NodeData("historyView", "History", historyObject,<History size={16} />);
    nodeList["headerView"] = headerNode;
    if (crData.isFetched == true) {
      nodeList["historyView"] = historyNode;
    }
    this.setState({ nodeList: nodeList });
  };
  nodeOnSelect = (selectedNode) => {
    let crData = this.state.crData;
    this.setState({ selectedNodeKey: selectedNode });
    if (selectedNode == "headerView") {
      this.setCustomerReturnHeaderView();
    } else if (selectedNode == "historyView") {
      this.setCustomerReturnHistoryView();
    }
  };
  setCustomerReturnHeaderView = () => {
    this.closeAllNodeViews();
    this.setState({
      isCustomerReturnListFormOpen: false,
      isCustomerReturnEntryFormOpen: true,
      isCustomerReturnHistoryFormOpened: false,
    });
  };
  setCustomerReturnHistoryView = () => {
    this.closeAllNodeViews();
    this.setState({
      isShowSaveButton: false,
      isShowClearCriteriaButton: false,
      isShowClearErrorButton: true,
      isCustomerReturnListFormOpen: false,
      isCustomerReturnEntryFormOpen: false,
      isCustomerReturnHistoryFormOpened: true,
    });
  };
  getHistoryView() {
    return (
      <CustomerReturnHistoryDetailsForm
        {...this.state}
        crData={this.state.crData}
        handleSortingStatusTrackChange={this.handleSortingStatusTrackChange}
      />
    );
  }
  hideAlertCallBack = (msgType, isDisplayed) => {
    this.setState({ isShowAlert: isDisplayed });
  };
  unApproveCustomerReturnResponse = (response) => {
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Loading...",
    });
    let isSuccess = this.handleResponse(response.data);
    if (
      response.data !== null &&
      response.data.customerReturn !== null &&
      isSuccess
    ) {
      let cr = response.data.customerReturn;
      if (cr !== null) {
        this.setState({
          crData: cr,
          isShowUnApprovePopup: false,
        });
        this.setState({
          isShowProgressBarPopup: false,
          progressLoadingText: "",
        });
        if (this.isLocked) {
          this.code = cr.code;
          this.unlockCustomerReturn(cr.code, false);
        }
        // this.unlockCustomerReturn(cr.code, false);
        // this.editCustomerReturn(cr.code);
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  unApproveCustomerReturnError = (error) => {
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
    ShowError("Error : " + error);
  };

  saveUnApproveCustomerReturn = () => {
    let request = new RestCustomerReturnBeanRequest();
    request.customerReturnBean = this.state.crData;
    request.specialReason = this.state.reasonData.code;
    if (SecurityAccessManager.CustomerReturnUnApproval_IsAccessible()) {
      CustomerReturnService.unApproveCustomerReturn(
        request,
        this.unApproveCustomerReturnResponse,
        this.unApproveCustomerReturnError
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  onUnApproveReasonChange = (e) => {
    let code = e.target.value;
    this.state.showAutoCompleteUnApproveReasonList = true;

    let reasonData = this.state.reasonData;
    let showAutoCompleteList = this.state.showAutoCompleteUnApproveReasonList;

    if (isEmpty(code)) {
      this.state.showAutoCompleteUnApproveReasonList = false;
      let showAutoCompleteList = this.state.showAutoCompleteUnApproveReasonList;
      let reason = this.state.reasonData;
      reason.code = "";
      reason.description = "";
      let suggestion = [];

      this.setState({
        showAutoCompleteUnApproveReasonList: showAutoCompleteList,
        reasonData: reason,
        unApproveReasonPageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && code !== "") {
      this.readUnApproveReasonBySearchString(code);
    }
    if (e.target.name == "code") {
      reasonData["code"] = e.target.value;
      let reasonList = this.state.unApproveReasons;
      reasonList.map((rsn) => {
        if (rsn.code == e.target.value) {
          reasonData["code"] = rsn.code;
          this.state.showAutoCompleteUnApproveReasonList = false;
          let showAutoCompleteList =
            this.state.showAutoCompleteUnApproveReasonList;
          this.setState({
            showAutoCompleteUnApproveReasonList: showAutoCompleteList,
          });
        }
      });
    }

    this.setState({ reasonData: reasonData });
  };
  readUnApproveReasonBySearchString(searchString) {
    let reasonData = this.state.unApproveReasons;
    let simpleAutoCompleteList = new Array();
    if (reasonData.length > 0 && reasonData != null) {
      reasonData.map((reasons) => {
        let simpleItemBean = {
          code: reasons.code,
          description: reasons.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;

    let filteredSuggestions = new Array();

    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompleteLocationLists) =>
        simpleAutoCompleteLocationLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({
      unApproveReasonPageListForAutoCompleteList: filteredSuggestions,
    });
  }
  unApproveReasonEnterKeyEventHandler = (e) => {
    let reasonData = this.state.reasonData;
    let code = e.target.value;

    reasonData["code"] = e.target.value;
    let reasonList = this.state.unApproveReasons;
    let reasonCodeBean = null;
    reasonList.map((rsn) => {
      if (rsn.code == e.target.value) {
        reasonCodeBean = rsn;
      }
    });
    if (!isEmpty(reasonCodeBean)) {
      let reasonData = this.state.reasonData;
      reasonData.code = reasonCodeBean.code;
      this.setState({
        reasonData: reasonData,
        unApproveReasonPageListForAutoCompleteList: new Array(),
      });
    }
  };
  displayAutoCompleteUnApproveReasonList = (showAutoCompleteList) => {
    this.setState({
      showAutoCompleteUnApproveReasonList: showAutoCompleteList,
    });
  };
  unApproveCustomerReturn = () => {
    this.openReasonCapture(2);
  };
  onUnApproveReasonContinue = () => {
    this.saveUnApproveCustomerReturn();
    this.closeReasonModelCallBack();
  };
  onReasonDescChange = (e) => {
    let reasonData = this.state.reasonData;
    reasonData[e.target.name] = e.target.value;
    this.setState({ reasonData: reasonData });
  };
  onReasonChange = (e) => {
    let code = e.target.value;
    this.state.showAutoCompleteReasonList = true;

    let reasonData = this.state.reasonData;
    let showAutoCompleteList = this.state.showAutoCompleteReasonList;

    if (isEmpty(code)) {
      this.state.showAutoCompleteReasonList = false;
      let showAutoCompleteList = this.state.showAutoCompleteReasonList;
      let reason = this.state.reasonData;
      reason.code = "";
      reason.description = "";
      let suggestion = [];

      this.setState({
        showAutoCompleteReasonList: showAutoCompleteList,
        reasonData: reason,
        reasonPageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && code !== "") {
      this.readReasonBySearchString(code);
    }
    if (e.target.name == "code") {
      reasonData["code"] = e.target.value;
      let reasonList = this.state.cancelReasons;
      reasonList.map((rsn) => {
        if (rsn.code == e.target.value) {
          reasonData["code"] = rsn.code;
          this.state.showAutoCompleteReasonList = false;
          let showAutoCompleteList = this.state.showAutoCompleteReasonList;
          this.setState({ showAutoCompleteReasonList: showAutoCompleteList });
        }
      });
    }

    this.setState({ reasonData: reasonData });
  };
  readReasonBySearchString(searchString) {
    let reasonData = this.state.cancelReasons;
    let simpleAutoCompleteList = new Array();
    if (reasonData.length > 0 && reasonData != null) {
      reasonData.map((reasons) => {
        let simpleItemBean = {
          code: reasons.code,
          description: reasons.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;

    let filteredSuggestions = new Array();

    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompleteLocationLists) =>
        simpleAutoCompleteLocationLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({ reasonPageListForAutoCompleteList: filteredSuggestions });
  }
  reasonEnterKeyEventHandler = (e) => {
    let reasonData = this.state.reasonData;
    let code = e.target.value;

    reasonData["code"] = e.target.value;
    let reasonList = this.state.cancelReasons;
    let reasonCodeBean = null;
    reasonList.map((rsn) => {
      if (rsn.code == e.target.value) {
        reasonCodeBean = rsn;
      }
    });
    if (!isEmpty(reasonCodeBean)) {
      let reasonData = this.state.reasonData;
      reasonData.code = reasonCodeBean.code;
      this.setState({
        reasonData: reasonData,
        reasonPageListForAutoCompleteList: new Array(),
      });
    }
  };
  displayAutoCompleteReasonList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteReasonList: showAutoCompleteList });
  };
  closeReasonModelCallBack = () => {
    this.setState({
      isShowCancelReasonPopup: false,
      reasonData: new ReasonBean(),
      showAutoCompleteReasonList: false,
      reasonPageListForAutoCompleteList: new Array(),

      showAutoCompleteUnApproveReasonList: false,
      unApproveReasonPageListForAutoCompleteList: new Array(),
      isShowUnApproveReasonPopup: false,
    });
  };
  openReasonCapture = (type) => {
    if (type === 1) {
      this.setState({
        isShowCancelReasonPopup: true,
      });
    } else if (type === 2) {
      this.setState({
        isShowUnApproveReasonPopup: true,
      });
    }
    this.setState({
      showAutoCompleteReasonList: false,
      reasonPageListForAutoCompleteList: new Array(),
      showAutoCompleteUnApproveReasonList: false,
      unApproveReasonPageListForAutoCompleteList: new Array(),
    });
  };

  cancelCustomerReturn = () => {
    this.openReasonCapture(1);
  };
  onCancelReasonContinue = () => {
    this.saveCancelCustomerReturn();
    this.closeReasonModelCallBack();
  };

  saveCancelCustomerReturnResponse = (response) => {
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Loading...",
    });
    let isSuccess = this.handleResponse(response.data);

    if (
      !isEmpty(response.data) &&
      !isEmpty(response.data.customerReturn) &&
      isSuccess
    ) {
      let cr = response.data.customerReturn;
      if (cr !== null) {
        this.setState({
          crData: cr,
        });
        this.setState({
          isShowProgressBarPopup: false,
          progressLoadingText: "",
        });
        if (this.isLocked) {
          this.code = cr.code;
          this.unlockCustomerReturn(cr.code);
        }
        // this.unlockCustomerReturn(cr.code, false);
        // this.editCustomerReturn(cr.code);
      }
    }
  };
  saveCancelCustomerReturnError = (error) => {
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
    ShowError("Error : " + error);
  };
  saveCancelCustomerReturn = () => {
    let crData = this.state.crData;
    let input = new RestCustomerReturnBeanRequest();
    input.customerReturnBean = crData;
    input.reason = this.state.reasonData;

    if (SecurityAccessManager.CustomerReturnCancellation_IsAccessible()) {
      CustomerReturnService.cancelCustomerReturn(
        input,
        this.saveCancelCustomerReturnResponse,
        this.saveCancelCustomerReturnError
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  lnkCustomerModule = (code) => {
    let customerCode = this.state.crData.customerCode;
    if (customerCode !== "" && customerCode !== undefined) {
      this.setState({
        isShowCustomerModule: true,
        moduleForPopup: (
          <PopupCustomerModule
            customerCode={customerCode}
            onModuleExit={this.onPopupModalExit}
          />
        ),
      });
    }
  };
  viewARModule = (code) => {
    if (code !== "" && code !== undefined) {
      this.setState({
        isShowARModule: true,
        moduleForPopup: (
          <PopupARModule code={code} onModuleExit={this.onPopupModalExit} />
        ),
      });
    }
  };
  viewInvoiceModule = (code) => {
    if (code !== "" && code !== undefined) {
      this.setState({
        isShowInvoiceModule: true,
        moduleForPopup: (
          <PopupInvoiceModule
            invoiceCode={code}
            onModuleExit={this.onPopupModalExit}
          />
        ),
      });
    }
  };
  openCustomerOnOrderInq = (code) => {
    if (code !== "" && code !== undefined && code !== NEW_ENTRY) {
      this.setState({
        isShowCustomerOnOrderInq: true,
        moduleForPopup: (
          <PopupCustomerOnOrderInq
            customerCode={code}
            onModuleExit={this.onPopupModalExit}
          />
        ),
      });
    }
  };
  openCustomerTransactionsInq = (code) => {
    if (code !== "" && code !== undefined && code !== NEW_ENTRY) {
      this.setState({
        isShowCustomerTransactionsInq: true,
        moduleForPopup: (
          <PopupCustomerTransactionsInq
            customerCode={code}
            onModuleExit={this.onPopupModalExit}
          />
        ),
      });
    }
  };
  openCustomerStatisticsInq = (code) => {
    if (code !== "" && code !== undefined && code !== NEW_ENTRY) {
      this.setState({
        isShowCustomerStatisticsInq: true,
        moduleForPopup: (
          <PopupCustomerStatisticsInq
            customerCode={code}
            onModuleExit={this.onPopupModalExit}
          />
        ),
      });
    }
  };
  openCustomerSalesHistoryInq = (code) => {
    if (code !== "" && code !== undefined && code !== NEW_ENTRY) {
      this.setState({
        isShowCustomerSalesHistoryInq: true,
        moduleForPopup: (
          <PopupCustomerSalesHistoryInq
            customerCode={code}
            onModuleExit={this.onPopupModalExit}
          />
        ),
      });
    }
  };
  openCustomerMostRecentFabricsInq = (code) => {
    if (code !== "" && code !== undefined && code !== NEW_ENTRY) {
      this.setState({
        isShowCustomerMostRecentFabricsInq: true,
        moduleForPopup: (
          <PopupCustomerMostRecentFabricsInq
            customerCode={code}
            onModuleExit={this.onPopupModalExit}
          />
        ),
      });
    }
  };
  openCustomerCurrentAgingInq = (code) => {
    if (code !== "" && code !== undefined && code !== NEW_ENTRY) {
      this.setState({
        isCustomerCurrentAgingInq: true,
        moduleForPopup: (
          <PopupCustomerCurrentAgingInq
            customerCode={code}
            onModuleExit={this.onPopupModalExit}
          />
        ),
      });
    }
  };
  closeModalCallBack = (isOpen) => {
    this.setState({
      isShowInvoiceModule: isOpen,
      isShowARModule: isOpen,
      isShowCustomerModule: isOpen,
      isShowCustomerOnOrderInq: isOpen,
      isShowCustomerTransactionsInq: isOpen,
      isShowCustomerStatisticsInq: isOpen,
      isShowCustomerSalesHistoryInq: isOpen,
      isShowCustomerMostRecentFabricsInq: isOpen,
      isCustomerCurrentAgingInq: isOpen,
      moduleForPopup: [],
    });
  };
  generateCreditMemoResponse = (response) => {
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Generating...",
    });
    if (!isEmpty(response.data) && !isEmpty(response.data.creditMemo)) {
      let cr = response.data.infos;
      let infoMsg = "";
      let successMsg = [];
      cr.map((info) => (infoMsg = infoMsg + info.messageDescription));
      successMsg.push(infoMsg);
      this.setState({
        alertMessage: successMsg,
        alertType: "success",
        isShowAlert: true,
      });
      this.setState({
        isShowProgressBarPopup: false,
        progressLoadingText: "",
      });
    } else {
      let cr = response.data.errors;
      let infoMsg = "";
      let errMsg = [];
      cr.map((info) => (infoMsg = infoMsg + info.messageDescription));
      errMsg.push(infoMsg);
      this.setState({
        alertMessage: errMsg,
        alertType: "danger",
        isShowAlert: true,
      });
      this.setState({
        isShowProgressBarPopup: false,
        progressLoadingText: "",
      });
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  generateCreditMemoError = (error) => {
    ShowError("Error : " + error);
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  generateCreditMemo = () => {
    let request = new RestReadRequest();
    request.companyCode = this.companyCode;
    request.code = this.state.crData.code;

    if (SecurityAccessManager.CustomerReturnCreation_IsAccessible()) {
      CustomerReturnService.createCreditMemoForCustomerReturn(
        request,
        this.generateCreditMemoResponse,
        this.generateCreditMemoError
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  handleSortingChange = (accessor) => {
    let sortField = accessor;
    let order = this.state.order;
    let sortOrder = accessor === sortField && order === "asc" ? "desc" : "asc";
    this.setState({
      order: sortOrder,
    });
    this.handleSorting(sortField, sortOrder);
  };
  handleSorting = (sortField, sortOrder) => {
    let custReturnData = this.state.custReturnData;
    if (sortField) {
      const sorted = [...custReturnData].sort((a, b) => {
        if (a[sortField] === null) return 1;
        if (b[sortField] === null) return -1;
        if (a[sortField] === null && b[sortField] === null) return 0;
        return (
          a[sortField].toString().localeCompare(b[sortField].toString(), "en", {
            numeric: true,
          }) * (sortOrder === "asc" ? 1 : -1)
        );
      });
      this.setState({ custReturnData: sorted });
    }
  };
  onPopupModalExit = () => {
    this.closeModalCallBack(false);
  };

  invoiceOnChange = (e) => {
    if (this.state.isShowInvoiceLookup == true) {
      let crData = this.state.crData;
      let invoiceNumber = e.target.value;
      this.state.showAutoCompleteInvoiceList = true;
      let showAutoCompleteInvoiceList = this.state.showAutoCompleteInvoiceList;
      if (isEmpty(invoiceNumber)) {
        let crData = this.state.crData;
        crData.invoiceNumber = "";
        let suggestion = [];
        this.setState({
          showAutoCompleteInvoiceList: false,
          crData: crData,
          invoiceData: new InvoiceBean(),
          invoicePageListForAutoCompleteList: suggestion,
        });
      } else if (
        e.target.name == "invoiceNumber" &&
        showAutoCompleteInvoiceList === true &&
        invoiceNumber !== ""
      ) {
        this.readInvoiceBySearchString(e.target.value);
      }
      crData[e.target.name] = e.target.value.toUpperCase();
      this.setState({ crData: crData });
    } else {
      let errMsg = "CustomerCode is Required !!";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
        showAutoCompleteInvoiceList: false,
        invoicePageListForAutoCompleteList: new Array(),
      });
    }
  };
  invoiceEnterKeyEvent = (e) => {
    let invoiceNumber = e.target.value;
    let invoicePageListForAutoCompleteList =
      this.state.invoicePageListForAutoCompleteList;
    if (!isEmptyArray(invoicePageListForAutoCompleteList)) {
      this.readInvoiceDetail(invoiceNumber);
      this.setState({
        invoicePageListForAutoCompleteList: new Array(),
      });
    } else {
      let crData = this.state.crData;
      crData.invoiceNumber = "";
      let errMsg = "Invalid Invoice#!  No Invoice !!";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
        crData: crData,
      });
    }
  };
  // invoiceEnterKeyEvent = (e) => {
  //   let invoiceNumber = e.target.value;
  //   this.readInvoiceDetail(invoiceNumber);
  //   this.setState({
  //     invoicePageListForAutoCompleteList: new Array(),
  //   });
  // };
  displayInvoiceAutoCompleteList = (showAutoCompleteList) => {
    this.setState({
      showAutoCompleteInvoiceList: showAutoCompleteList,
    });
  };
  readInvoiceBySearchString = (searchString) => {
    let inv_crData = new InvoiceSearchCriteria();
    inv_crData.companyCode = this.companyCode;
    inv_crData.customerCode = this.state.crData.customerCode;
    inv_crData.invoiceNumberStartsWith = searchString;
    inv_crData.invoiceNumberContains = searchString;
    let inv_pageList = new RestPageListBean();
    inv_pageList.pageSize = 100;
    let inv_requestInput = new RestInvoiceListRequest();
    inv_requestInput.pageInput = inv_pageList;
    inv_requestInput.searchCriteria = inv_crData;
    InvoiceService.getInvoicePageList(
      inv_requestInput,
      this.loadInvoicesResponse,
      this.errorCallBack
    );
  };
  errorCallBack = (error) => {
    ShowError("Error : ", error);
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: " ",
    });
  };
  readInvoiceDetail = (invoiceNumber) => {
    let readrestInput = new RestReadRequest();
    readrestInput.companyCode = this.companyCode;
    readrestInput.code = invoiceNumber;
    InvoiceService.readInvoice(
      readrestInput,
      this.readInvoicesResponse,
      this.errorCallBack
    );
  };
  readInvoicesResponse = (response) => {
    if (response.data.invoice != null) {
      let crData = this.state.crData;
      let invoice = response.data.invoice;
      crData.invoiceNumber = invoice.code;
      let showAutoCompleteInvoiceList = false;
      this.setState({
        crData: crData,
        invoiceData: invoice,
        showAutoCompleteInvoiceList: showAutoCompleteInvoiceList,
      });
    } else {
      let errMsg = "Invalid Invoice#!  No Invoice !!";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  loadInvoicesResponse = (response) => {
    if (response.data != null && response.data.invoicePageList != null) {
      let invoiceData = response.data.invoicePageList.invoices;
      let simpleAutoCompleteList = new Array();
      if (!isEmptyArray(invoiceData)) {
        if (invoiceData.length > 0 && invoiceData != null) {
          invoiceData.map((obj) => {
            let simpleItemBean = {
              code: obj.code,
              description: "",
            };
            simpleAutoCompleteList.push(simpleItemBean);
          });
          this.setState({
            invoicePageListForAutoCompleteList: simpleAutoCompleteList,
          });
        }
      } else {
        this.setState({
          ShowAutoCompleteInvoiceList: false,
        });
      }
    }
  };

  handleSortingMerchandiseChange = (accessor) => {
    let sortField = accessor;
    let order = this.state.order;
    let sortOrder = accessor === sortField && order === "asc" ? "desc" : "asc";
    this.setState({
      order: sortOrder,
      sortField: sortField,
    });
    this.handleSortingMerchandise(sortField, sortOrder);
  };
  handleSortingMerchandise = (sortField, sortOrder) => {
    let list = this.state.merchandiseLineList;
    if (sortField && !isEmptyArray(list)) {
      const sorted = [...list].sort((a, b) => {
        if (a[sortField] === null) return 1;
        if (b[sortField] === null) return -1;
        if (a[sortField] === null && b[sortField] === null) return 0;
        return (
          a[sortField].toString().localeCompare(b[sortField].toString(), "en", {
            numeric: true,
          }) * (sortOrder === "asc" ? 1 : -1)
        );
      });
      this.setState({ merchandiseLineList: sorted });
    }
  };

  handleSortingStatusTrackChange = (accessor) => {
    let sortField = accessor;
    let order = this.state.order;
    let sortOrder = accessor === sortField && order === "asc" ? "desc" : "asc";
    this.setState({
      order: sortOrder,
      sortField: sortField,
    });
    this.handleSortingStatusTrack(sortField, sortOrder);
  };
  handleSortingStatusTrack = (sortField, sortOrder) => {
    let list = this.state.statusTrack;
    if (sortField && !isEmptyArray(list)) {
      const sorted = [...list].sort((a, b) => {
        if (a[sortField] === null) return 1;
        if (b[sortField] === null) return -1;
        if (a[sortField] === null && b[sortField] === null) return 0;
        return (
          a[sortField].toString().localeCompare(b[sortField].toString(), "en", {
            numeric: true,
          }) * (sortOrder === "asc" ? 1 : -1)
        );
      });
      this.setState({ statusTrack: sorted });
    }
  };

  render() {
    let crData = this.state.crData;
    let lines = this.state.invoiceLines;
    return (
      <div>
        <ProgressBar
          progressLoadingText={this.state.progressLoadingText}
          isShowPopup={this.state.isShowProgressBarPopup}
        />
        <AlertToolBox
          alertMsgList={this.state.alertMessage}
          alertErrorType={this.state.alertType}
          isShowAlert={this.state.isShowAlert}
          hideAlertCallBack={this.hideAlertCallBack}
        />
        <div>
          <ModuleToolBar
            onModuleExit={() => this.moduleExit()}
            onNewEntry={() => this.addNewEntry()}
            pageTitle={this.state.pageTitle}
            resetView={() => this.resetView()}
            isShowModuleSearchContainer={this.state.isShowModuleSearchContainer}
            isMaintenanceMode={!this.state.isCustomerReturnListFormOpen}
            moduleKeyCode={this.state.moduleKeyCode}
            onModuleKeyCodeChange={this.onModuleKeyCodeChange}
            onModuleKeyCodeWithCriteriaOnChange={
              this.onModuleKeyCodeWithCriteriaOnChange
            }
            selectButtonClick={this.selectButtonClick}
            onModuleKeyContainerButtonClick={this.editCustomerReturn}
            lookupRequired={true} //for f2 lookup
            lookupHandler={this.state.customerReturnLookupHandler} //for f2 lookup
            getModuleListView={this.getModuleListView}
            showCriteriaDialog={true} //for f2 lookup
            isResetView={this.state.isResetView}
            isFocusLookup={this.state.isFocusLookup}
          />
          {this.state.isCustomerReturnEntryFormOpen &&
            this.state.isViewMode == false && (
              <BaseToolBar
                extend_toolbar={
                  <CustomerReturnModuleToolBar
                    cancelCustomerReturn={this.cancelCustomerReturn}
                    approveCustomerReturn={this.approveCustomerReturn}
                    unApproveCustomerReturn={this.unApproveCustomerReturn}
                    generateCreditMemo={this.generateCreditMemo}
                    generateExcel={this.generateExcel}
                    isShowApproveButton={this.state.isShowApproveButton}
                    isShowUnApproveButton={this.state.isShowUnApproveButton}
                    isShowCancelButton={this.state.isShowCancelButton}
                    isShowExcelButton={this.state.isShowExcelButton}
                    isShowGenerateCreditMemoButton={
                      this.state.isShowGenerateCreditMemoButton
                    }
                  />
                }
                save={this.save}
                clearError={this.clearError}
                generatePDF={this.generatePDF}
                isShowSaveButton={this.state.isShowSaveButton}
                isShowClearCriteriaButton={this.state.isShowClearCriteriaButton}
                isShowClearErrorButton={this.state.isShowClearErrorButton}
                isShowPDFButton={this.state.isShowPDFButton}
                pageTitle={this.state.pageTitle}
              />
            )}
          {this.state.isCustomerReturnListFormOpen && (
            <CustomerReturnListForm
              {...this.state}
              loadFirst={this.loadFirst}
              loadNext={this.loadNext}
              loadPrevious={this.loadPrevious}
              loadLast={this.loadLast}
              editCustomerReturn={this.editCustomerReturn}
              filter={this.filter}
              resetFilteredCR={this.resetFilteredCR}
              resetFilter={this.resetFilter}
              listFormOnChange={this.listFormOnChange}
              handleSortingChange={this.handleSortingChange}
            />
          )}
          {this.state.isShowNodes && (
            <BaseNodeBar
              nodeList={this.state.nodeList}
              selectedModuleKey={this.state.selectedNodeKey}
              nodeOnSelect={this.nodeOnSelect}
              moduleStatus={this.state.moduleOrderStatus}
            />
          )}
          {!this.state.isShowNodes &&
            !this.state.isCustomerReturnListFormOpen &&
            !this.state.isCustomerReturnHistoryFormOpened &&
            this.state.isCustomerReturnEntryFormOpen}
          {this.state.isShowNodes &&
            !this.state.isCustomerReturnListFormOpen &&
            !this.state.isCustomerReturnHistoryFormOpened &&
            this.state.isCustomerReturnEntryFormOpen}
          {this.state.isShowNodes &&
            !this.state.isCustomerReturnListFormOpen &&
            this.state.isCustomerReturnHistoryFormOpened &&
            !this.state.isCustomerReturnEntryFormOpen &&
            this.getHistoryView()}
          {this.state.isCustomerReturnEntryFormOpen && (
            <CustomerReturnEntryForm
              {...this.state}
              onChange={this.onChange}
              onCustomerCodeChange={this.onCustomerCodeChange}
              customerCodeEnterKeyEventHandler={
                this.customerCodeEnterKeyEventHandler
              }
              displayAutoCustomerCompleteList={
                this.displayAutoCustomerCompleteList
              }
              openMerchandiseLineDetailDialog={
                this.openMerchandiseLineDetailDialog
              }
              fetchInvoiceOnClick={this.fetchInvoiceOnClick}
              deleteMerchandiseLine={this.deleteMerchandiseLine}
              getMerchandiseLineDetails={this.getMerchandiseLineDetails}
              lnkCustomerModule={this.lnkCustomerModule}
              openCustomerOnOrderInq={this.openCustomerOnOrderInq}
              openCustomerTransactionsInq={this.openCustomerTransactionsInq}
              openCustomerStatisticsInq={this.openCustomerStatisticsInq}
              openCustomerSalesHistoryInq={this.openCustomerSalesHistoryInq}
              openCustomerMostRecentFabricsInq={
                this.openCustomerMostRecentFabricsInq
              }
              openCustomerCurrentAgingInq={this.openCustomerCurrentAgingInq}
              closeModalCallBack={this.closeModalCallBack}
              invoiceEnterKeyEvent={this.invoiceEnterKeyEvent}
              displayInvoiceAutoCompleteList={
                this.displayInvoiceAutoCompleteList
              }
              invoiceOnChange={this.invoiceOnChange}
              handleSortingMerchandiseChange={
                this.handleSortingMerchandiseChange
              }
            />
          )}
          <ReasonCaptureComponent
            ref={this.unApproveReasonDialogRef}
            reasons={this.state.unApproveReasons}
            reasonData={this.state.reasonData}
            title="CustomerReturn UnApprove"
            onChange={this.onUnApproveReasonChange}
            onClick={this.onUnApproveReasonContinue}
            isShowPopup={this.state.isShowUnApproveReasonPopup}
            closeReasonModelCallBack={this.closeReasonModelCallBack}
            reasonEnterKeyEventHandler={
              this.unApproveReasonEnterKeyEventHandler
            }
            reasonPageListForAutoCompleteList={
              this.state.unApproveReasonPageListForAutoCompleteList
            }
            displayAutoCompleteReasonList={
              this.displayAutoCompleteUnApproveReasonList
            }
            showAutoCompleteReasonList={
              this.state.showAutoCompleteUnApproveReasonList
            }
            onReasonDescChange={this.onReasonDescChange}
          />
          <ReasonCaptureComponent
            ref={this.cancelReasonDialogRef}
            reasons={this.state.cancelReasons}
            reasonData={this.state.reasonData}
            title="CustomerReturn Cancel"
            onChange={this.onReasonChange}
            onClick={this.onCancelReasonContinue}
            isShowPopup={this.state.isShowCancelReasonPopup}
            closeReasonModelCallBack={this.closeReasonModelCallBack}
            reasonEnterKeyEventHandler={this.reasonEnterKeyEventHandler}
            reasonPageListForAutoCompleteList={
              this.state.reasonPageListForAutoCompleteList
            }
            displayAutoCompleteReasonList={this.displayAutoCompleteReasonList}
            showAutoCompleteReasonList={this.state.showAutoCompleteReasonList}
            onReasonDescChange={this.onReasonDescChange}
          />
          <MultiViewPopup
            popupLvlClass={"popupSizeLevelX5"}
            isModulePopup={false}
            isShowPopup={this.state.isShowMerchandiseLinePopup}
            closeOnEsc={false}
            closeAlertModalCallBack={
              this.closeMerchandiseLineAlertModalCallBack
            }
            title={"MERCHANDISE LINE"}
            closeOnDocumentClick={false}
            lineFunctionalityForm={this.lineFunctionalityForm}
            alertContainerBox={
              <AlertToolBox
                alertMsgList={this.state.alertMessage}
                alertErrorType={this.state.alertType}
                isShowAlert={this.state.isShowAlertLvl5}
                hideAlertCallBack={this.hideAlertCallBackLvl5}
              />
            }
            headerButtonContainer={
              <div className="floatLeft">
                <Button
                  className="header_buttons enterFocus"
                  size="sm"
                  onClick={(e) => this.addorUpdateMerchandiseLine(e)}
                  disabled={this.state.disableCRFormFields}
                >
                  Add/Update
                </Button>
                <Button
                  className="header_buttons enterFocus"
                  size="sm"
                  disabled={this.state.disableCRFormFields}
                  onClick={(e) => this.clearMerchandiseLineValues(e)}
                >
                  Clear
                </Button>
              </div>
            }
            content={
              <div>
                <Row>
                  <Col sm="2">
                    {this.state.is3PL ? (
                      <FormLabel>Item</FormLabel>
                    ) : (
                      <FormLabel>FabricStyle</FormLabel>
                    )}
                  </Col>
                  <Col sm="4">
                    <InputTextbox
                      name="fabricStyleCode"
                      onChange={this.onMerchandiseChange}
                      value={this.state.merchandiseLineData.fabricStyleCode}
                      readOnly={true}
                    />{" "}
                  </Col>
                  <Col sm="6">
                    <InputTextbox
                      name="fabricStyleName"
                      type="text"
                      onChange={this.onMerchandiseChange}
                      readOnly={true}
                      value={this.state.merchandiseLineData.fabricStyleName}
                    />{" "}
                  </Col>
                </Row>
                <Row>
                  <Col sm="2">
                    {" "}
                    <FormLabel>Color</FormLabel>{" "}
                  </Col>
                  <Col sm="4">
                    <InputTextbox
                      name="colorCode"
                      onChange={this.onMerchandiseChange}
                      value={this.state.merchandiseLineData.colorCode}
                      readOnly={true}
                    />{" "}
                  </Col>
                  <Col sm="2">
                    {" "}
                    <FormLabel>Invoice#</FormLabel>{" "}
                  </Col>
                  <Col sm="4">
                    <InputTextbox
                      name="invoiceNumber"
                      type="text"
                      onChange={this.onMerchandiseChange}
                      readOnly={true}
                      value={this.state.merchandiseLineData.invoiceNumber}
                    />{" "}
                  </Col>
                </Row>
                <Row>
                  <Col sm="2">
                    {" "}
                    <FormLabel>Price</FormLabel>{" "}
                  </Col>
                  <Col sm="4">
                    <NumberFormatInputbox
                      value={this.state.merchandiseLineData.price}
                      onChange={this.onMerchandiseChange}
                      className=" text-right"
                      decimalScale={2}
                      name={"price"}
                      disabled={this.state.disableCRFormFields}
                      isMandatory={true}
                    />
                  </Col>{" "}
                  <Col sm="2">
                    {" "}
                    <FormLabel>Width</FormLabel>{" "}
                  </Col>
                  <Col sm="4">
                    <InputTextbox
                      name="widthCode"
                      type="text"
                      onChange={this.onMerchandiseChange}
                      readOnly={true}
                      value={this.state.merchandiseLineData.widthCode}
                    />{" "}
                  </Col>
                </Row>
                <Row>
                  <Col sm="2">
                    <FormLabel>TotQty</FormLabel>
                  </Col>
                  <Col sm="4">
                    <NumberFormatInputbox
                      value={
                        this.state.merchandiseLineData.lineTotalReturnQuantity
                      }
                      onChange={this.onMerchandiseChange}
                      className="text-right"
                      decimalScale={2}
                      name={"lineTotalReturnQuantity"}
                      disabled={this.state.disableCRFormFields}
                      isMandatory={true}
                    />
                  </Col>

                  <Col sm="2">
                    {" "}
                    <FormLabel>UOM</FormLabel>{" "}
                  </Col>
                  <Col sm="4">
                    <InputTextbox
                      name="uomCode"
                      type="text"
                      onChange={this.onMerchandiseChange}
                      readOnly={true}
                      value={this.state.merchandiseLineData.uomCode}
                    />{" "}
                  </Col>
                </Row>
                <Row>
                  <Col sm="2">
                    <FormLabel>Location</FormLabel>{" "}
                  </Col>
                  <Col sm="4">
                    <InputTextbox
                      onChange={this.locationOnChange}
                      placeholder="locationCode"
                      name="locationCode"
                      value={this.state.merchandiseLineData.locationCode}
                      lookupRequired={true}
                      lookupHandler={this.state.warehouseLookupHandler}
                      showCriteriaDialog={true}
                      enterKeyEventHandler={this.locationEnterKeyEvent}
                      autoCompleteListData={
                        this.state.locationPageListForAutoCompleteList
                      }
                      enableAutoCompleteTextBox={true}
                      displayAutoCompleteList={
                        this.displayLocationAutoCompleteList
                      }
                      showAutoCompleteList={
                        this.state.isShowAutoCompleteLocationList
                      }
                      disabled={this.state.disableCRFormFields}
                      isMandatory={true}
                    />
                  </Col>

                  <Col sm="2">
                    <FormLabel>
                      {this.state.is3PL ? "Inventory#" : "RollSKU#"}
                    </FormLabel>
                  </Col>
                  <Col sm="4">
                    <InputTextbox
                      name="rollSkuNumber"
                      type="text"
                      placeholder={
                        this.props.is3PL ? "Enter Inventory#" : "Enter RollSKU#"
                      }
                      value={this.state.merchandiseLineData.rollSkuNumber}
                      onChange={this.onMerchandiseChange}
                      readOnly={true}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col sm="2">
                    <FormLabel>Roll#</FormLabel>
                  </Col>
                  <Col sm="4">
                    <InputTextbox
                      name="rollNumber"
                      type="text"
                      placeholder="Enter rollNumber"
                      value={this.state.merchandiseLineData.rollNumber}
                      onChange={this.onMerchandiseChange}
                      isMandatory={true}
                    />
                  </Col>
                  <Col sm="2">
                    <FormLabel>VendorBatch#</FormLabel>
                  </Col>
                  <Col sm="4">
                    <InputTextbox
                      name="vendorBatchNumber"
                      type="text"
                      placeholder="Enter vendorBatchNumber"
                      value={this.state.merchandiseLineData.vendorBatchNumber}
                      onChange={this.onMerchandiseChange}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col sm="2">
                    <FormLabel>Box#</FormLabel>
                  </Col>
                  <Col sm="4">
                    <InputTextbox
                      name="boxNumber"
                      type="text"
                      placeholder="Enter boxNumber"
                      value={this.state.merchandiseLineData.boxNumber}
                      onChange={this.onMerchandiseChange}
                    />
                  </Col>

                  <Col sm="2">
                    <FormLabel>Amount </FormLabel>{" "}
                  </Col>
                  <Col sm="4">
                    <NumberFormatInputbox
                      value={this.state.merchandiseLineData.lineTotalAmount}
                      onChange={this.onMerchandiseChange}
                      className="summary_input text-right"
                      decimalScale={2}
                      name={"lineTotalAmount"}
                      disabled={true}
                    />
                  </Col>
                </Row>
              </div>
            }
          />
        </div>
        <div>
          {" "}
          <MultiViewPopup
            popupLvlClass={"popupSizeLevel1"}
            isModulePopup={false}
            isShowPopup={this.state.isShowFetchInvoicePopup}
            closeOnEsc={false}
            closeAlertModalCallBack={this.closeAlertModalCallBack}
            title={"Fetch Invoice"}
            closeOnDocumentClick={false}
            lineFunctionalityForm={this.lineFunctionalityForm}
            alertContainerBox={
              <AlertToolBox
                alertMsgList={this.state.alertMessage}
                alertErrorType={this.state.alertType}
                isShowAlert={this.state.isShowAlertLvl3}
                hideAlertCallBack={this.hideAlertCallBackLvl3}
              />
            }
            headerButtonContainer={
              <div className="floatLeft">
                <Button
                  className="header_buttons enterFocus"
                  size="sm"
                  onClick={(e) => this.addInvoiceLinesToReturn(e)}
                >
                  Add Lines
                </Button>
              </div>
            }
            content={
              <div className="popup_inquiry_load_table_body">
                <Row>
                  <Col className="align-items-left" sm="2">
                    <FormLabel>CustomerCode</FormLabel>
                  </Col>
                  <Col sm="2">
                    <InputTextbox readOnly={true} value={crData.customerCode} />{" "}
                  </Col>
                  <Col sm="3">
                    <InputTextbox readOnly={true} value={crData.customerName} />{" "}
                  </Col>
                  <Col className="align-items-left" sm="2">
                    <FormLabel>Invoice</FormLabel>
                  </Col>
                  <Col sm="2">
                    <InputTextbox
                      readOnly={true}
                      value={crData.invoiceNumber}
                    />{" "}
                  </Col>
                </Row>
                <Row className="d-flex justify-content-center">
                  <Col sm="1">
                    <Button
                      size="sm"
                      id="fabric_Add_Button"
                      onClick={(e) => this.selectAllItem(e)}
                    >
                      {" "}
                      SelectAll{" "}
                    </Button>
                  </Col>
                  <Col sm="1">
                    <Button
                      size="sm"
                      id="fabric_Add_Button"
                      onClick={(e) => this.unSelectAllItem(e)}
                    >
                      {" "}
                      UnSelectAll{" "}
                    </Button>
                  </Col>
                </Row>{" "}
                {/* <EditableDataGrid
                  columnsList={this.columnDefinitions()}
                  dataList={lines}
                /> */}
                <CustomTable
                  columns={this.customerReturnColumns()}
                  data={lines}
                  label={"Customer Return List"}
                />
              </div>
            }
          />
        </div>
      </div>
    );
  }
}
class CustomerReturnListForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.searchRef = React.createRef();
  }
  componentDidMount() {
    if (this.searchRef.current != null) {
      this.searchRef.current.focus();
    }
  }
  listFormOnChange = (e) => {
    this.props.listFormOnChange(e);
  };
  filter = (e) => {
    if (e.detail === 1) this.props.filter();
  };
  resetFilter = (e) => {
    if (e.detail === 1) this.props.resetFilter();
  };
  loadFirst = (e) => {
    if (e.detail === 1) this.props.loadFirst();
  };
  loadNext = (e) => {
    if (e.detail === 1) this.props.loadNext();
  };
  loadPrevious = (e) => {
    if (e.detail === 1) this.props.loadPrevious();
  };
  loadLast = (e) => {
    if (e.detail === 1) this.props.loadLast();
  };
  editCustomerReturn = (e, val) => {
    if (e.detail === 1) this.props.editCustomerReturn(val);
  };
  handleSortingChange = (e, accessor) => {
    if (e.detail === 1) this.props.handleSortingChange(accessor);
  };
  onKeyDown = (e) => {
    if (e.keyCode == 13) {
      this.props.filter();
    }
  };
  render() {
    let custReturnData = new Array();
    custReturnData = this.props.custReturnData;
    let criteria = this.props.criteria;
    let pageList = this.props.pageList;
    let totalPages = 0;
    let pageSize = pageList.pageSize;
    let totalCount = pageList.totalCount;
    totalPages = totalCount / pageSize;
    totalPages += totalCount % pageSize == 0 ? 0 : 1;
    return (
      <div>
        <div className="secondary_module_header">
          <div className="secondary_module_header_title">
            <FormLabel className="secondary_module_search_color">
              Search
            </FormLabel>
            <span className="secondary_module_header_title_2">
              <InputTextbox
                ref={this.searchRef}
                name="customerReturnNumberContains"
                type="text"
                value={criteria.customerReturnNumberContains}
                placeholder="Enter Value to Filter.."
                onChange={this.listFormOnChange}
                onKeyDown={this.onKeyDown}
              />
            </span>

            <span className="px-2"></span>
            <Button size="sm" onClick={(e) => this.filter(e)}>
              Filter
            </Button>
            <span className="px-2"></span>
            <Button size="sm" onClick={(e) => this.resetFilter(e)}>
              Reset
            </Button>
          </div>
          <div className="module_header_secondary_buttons">
            <span>
              PAGE - {pageList.currentPage} OF {parseInt(totalPages)}
            </span>
            <Button
              size="sm"
              className="secondary_header_buttons"
              onClick={(e) => this.loadFirst(e)}
            >
              First
            </Button>
            <Button
              size="sm"
              className="secondary_header_buttons"
              onClick={(e) => this.loadPrevious(e)}
            >
              Previous
            </Button>
            <Button
              size="sm"
              className="secondary_header_buttons"
              onClick={(e) => this.loadNext(e)}
            >
              Next
            </Button>
            <Button
              size="sm"
              className="secondary_header_buttons"
              onClick={(e) => this.loadLast(e)}
            >
              Last
            </Button>
          </div>
        </div>
        <div className="div_Custom_2">
          <Table id="fabrics_tables_default">
            <thead>
              <tr>
                <th onClick={(e) => this.handleSortingChange(e, "code")}>
                  CR#
                  {this.props.order === "desc" &&
                  this.props.sortField === "code" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th
                  onClick={(e) =>
                    this.handleSortingChange(e, "customerReturnDate")
                  }
                >
                  Date
                  {this.props.order === "desc" &&
                  this.props.sortField === "customerReturnDate" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th
                  onClick={(e) => this.handleSortingChange(e, "customerCode")}
                >
                  CustomerCode
                  {this.props.order === "desc" &&
                  this.props.sortField === "customerCode" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th
                  onClick={(e) => this.handleSortingChange(e, "customerName")}
                >
                  CustomerName
                  {this.props.order === "desc" &&
                  this.props.sortField === "customerName" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th
                  onClick={(e) => this.handleSortingChange(e, "invoiceNumber")}
                >
                  Invoice
                  {this.props.order === "desc" &&
                  this.props.sortField === "invoiceNumber" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th
                  onClick={(e) =>
                    this.handleSortingChange(e, "customerReturnStatus")
                  }
                >
                  Status
                  {this.props.order === "desc" &&
                  this.props.sortField === "customerReturnStatus" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th
                  onClick={(e) =>
                    this.handleSortingChange(e, "totalReturnAmount")
                  }
                >
                  TotalReturn
                  {this.props.order === "desc" &&
                  this.props.sortField === "totalReturnAmount" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th
                  onClick={(e) =>
                    this.handleSortingChange(e, "customerCurrencyCode")
                  }
                >
                  Currency
                  {this.props.order === "desc" &&
                  this.props.sortField === "customerCurrencyCode" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th
                  onClick={(e) =>
                    this.handleSortingChange(e, "createdSourceType")
                  }
                >
                  Source Type
                  {this.props.order === "desc" &&
                  this.props.sortField === "createdSourceType" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
              </tr>
            </thead>
            {custReturnData != null ? (
              <tbody>
                {custReturnData.map((ln, index) => (
                  <tr key={index}>
                    <td className="hyperLinkText">
                      <Button
                        variant="secondry"
                        className="hyperLinkText"
                        onClick={(e) => this.editCustomerReturn(e, ln.code)}
                      >
                        {ln.code}
                      </Button>
                    </td>
                    <td>{ln.customerReturnDate}</td>
                    <td>{ln.customerCode}</td>
                    <td>{ln.customerName}</td>
                    <td>{ln.invoiceNumber}</td>
                    <td>
                      {ModuleUtils.getCustomerReturnStatusCaption(
                        ln.customerReturnStatus
                      )}
                    </td>
                    <td className="text-end">{toCommaSeperatedAmount(ln.totalReturnAmount)}</td>
                    <td>{ln.customerCurrencyCode}</td>
                    <td>{ln.createdSourceType}</td>
                  </tr>
                ))}
              </tbody>
            ) : null}
          </Table>
        </div>
      </div>
    );
  }
}
class CustomerReturnEntryForm extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.custCodeRef = React.createRef();
    this.invCodeRef = React.createRef();
    this.state = {};
  }
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    this.setInputFocus();
    this.initLookupHandlers();
  }
  setInputFocus = () => {
    if (this.props.isFocus == true) this.custCodeRef.current.focus();
  };
  initLookupHandlers = () => {
    let customerLookupHandler = new CustomerLookupHandler(
      this.companyCode,
      "Customer"
    );
    this.setState({
      customerLookupHandler: customerLookupHandler,
    });
  };
  onChange = (e) => {
    this.props.onChange(e);
  };
  onCustomerCodeChange = (e) => {
    this.props.onCustomerCodeChange(e);
  };
  customerCodeEnterKeyEventHandler = (e) => {
    this.props.customerCodeEnterKeyEventHandler(e);
  };
  displayAutoCustomerCompleteList = (list) => {
    this.props.displayAutoCustomerCompleteList(list);
  };
  fetchInvoiceOnClick = (e) => {
    if (e.detail <= 1) this.props.fetchInvoiceOnClick();
  };

  openMerchandiseLineDetailDialog = (e) => {
    if (e.detail === 1) this.props.openMerchandiseLineDetailDialog(e);
  };

  getMerchandiseLineDetails = (e, rowData) => {
    this.props.getMerchandiseLineDetails(rowData);
    this.openMerchandiseLineDetailDialog(e);
  };
  handleMerchandiseLineClick = (e, val, rowData) => {
    if (e.detail === 1) this.getMerchandiseLineDetails(e, rowData);
  };

  closeModalCallBack = (isShowPopup) => {
    this.props.closeModalCallBack(isShowPopup);
  };
  closeAlertModalCallBack = (isShowPopup) => {
    this.props.closeAlertModalCallBack(isShowPopup);
  };
  lnkCustomerModule = (e, code) => {
    if (e.detail === 1) this.props.lnkCustomerModule(code);
  };
  openCustomerOnOrderInq = (e, code) => {
    if (e.detail === 1) this.props.openCustomerOnOrderInq(code);
  };
  openCustomerTransactionsInq = (e, code) => {
    if (e.detail === 1) this.props.openCustomerTransactionsInq(code);
  };
  openCustomerStatisticsInq = (e, code) => {
    if (e.detail === 1) this.props.openCustomerStatisticsInq(code);
  };
  openCustomerSalesHistoryInq = (e, code) => {
    if (e.detail === 1) this.props.openCustomerSalesHistoryInq(code);
  };
  openCustomerMostRecentFabricsInq = (e, code) => {
    if (e.detail === 1) this.props.openCustomerMostRecentFabricsInq(code);
  };
  openCustomerCurrentAgingInq = (e, code) => {
    if (e.detail === 1) this.props.openCustomerCurrentAgingInq(code);
  };
  deleteMerchandiseLine = (e, rowData) => {
    if (e.detail === 1) this.props.deleteMerchandiseLine(rowData);
  };

  hideAlertCallBack = (msgType, isDisplayed) => {
    this.props.hideAlertCallBack(msgType, isDisplayed);
  };
  invoiceOnChange = (e) => this.props.invoiceOnChange(e);
  invoiceEnterKeyEvent = (e) => {
    this.props.invoiceEnterKeyEvent(e);
  };
  displayInvoiceAutoCompleteList = (list) => {
    this.props.displayInvoiceAutoCompleteList(list);
  };
  handleSortingMerchandiseChange = (e, accessor) => {
    if (e.detail === 1) this.props.handleSortingMerchandiseChange(accessor);
  };

  render() {
    let crData = null;
    let disableCRFormFields = this.props.disableCRFormFields;
    let disableCRFetchFields = this.props.disableCRFetchFields;
    crData = this.props.crData;
    let merchandiseLines = [];
    let merchandiseLineList = this.props.merchandiseLineList;
    merchandiseLines = crData.merchandiseLines;

    const textAreaStyle = {
      height: "12em",
      width: "65em",
      resize: "none",
      padding: "2px",
      boxSizing: "border-box",
      fontSize: "15px",
    };
    return (
      <div>
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel0"}
          isShowPopup={this.props.isShowCustomerModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.props.moduleForPopup}
        ></MultiViewPopup>
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel0"}
          isShowPopup={this.props.isShowARModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.props.moduleForPopup}
        ></MultiViewPopup>
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel0"}
          isShowPopup={this.props.isShowInvoiceModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.props.moduleForPopup}
        ></MultiViewPopup>
        <MultiViewPopup
          popupLvlClass={"popupSizeLevel0"}
          isModulePopup={true}
          id="modulePopup"
          isShowPopup={this.props.isShowCustomerOnOrderInq}
          closeModalCallBack={this.closeModalCallBack}
          module={this.props.moduleForPopup}
        ></MultiViewPopup>
        <MultiViewPopup
          popupLvlClass={"popupSizeLevel0"}
          isModulePopup={true}
          id="modulePopup"
          isShowPopup={this.props.isShowCustomerTransactionsInq}
          closeModalCallBack={this.closeModalCallBack}
          module={this.props.moduleForPopup}
        ></MultiViewPopup>
        <MultiViewPopup
          popupLvlClass={"popupSizeLevel0"}
          isModulePopup={true}
          id="modulePopup"
          isShowPopup={this.props.isShowCustomerStatisticsInq}
          closeModalCallBack={this.closeModalCallBack}
          module={this.props.moduleForPopup}
        ></MultiViewPopup>
        <MultiViewPopup
          popupLvlClass={"popupSizeLevel0"}
          isModulePopup={true}
          id="modulePopup"
          isShowPopup={this.props.isShowCustomerSalesHistoryInq}
          closeModalCallBack={this.closeModalCallBack}
          module={this.props.moduleForPopup}
        ></MultiViewPopup>
        <MultiViewPopup
          popupLvlClass={"popupSizeLevel0"}
          isModulePopup={true}
          id="modulePopup"
          isShowPopup={this.props.isShowCustomerMostRecentFabricsInq}
          closeModalCallBack={this.closeModalCallBack}
          module={this.props.moduleForPopup}
        ></MultiViewPopup>
        <MultiViewPopup
          popupLvlClass={"popupSizeLevel0"}
          isModulePopup={true}
          id="modulePopup"
          isShowPopup={this.props.isCustomerCurrentAgingInq}
          closeModalCallBack={this.closeModalCallBack}
          module={this.props.moduleForPopup}
        ></MultiViewPopup>
        <div className="header_div">
          <div>
            <Row>
              <Col className="align-items-left" sm="1">
                <FormLabel>Date</FormLabel>
              </Col>
              <Col sm="2">
                <DatePickerComponent
                  name="customerReturnDate"
                  value={crData.customerReturnDate}
                  onChange={this.onChange}
                  isMandatory={true}
                />
              </Col>
              <Col className="so-align-items-left" sm="1">
                <FormLabel
                  className="hyperlinklabel"
                  onClick={(e) => this.lnkCustomerModule(e)}
                >
                  Customer
                </FormLabel>{" "}
                <Col>
                  {crData.customerCode != "" &&
                  crData.customerCode != NEW_ENTRY &&
                  crData.customerCode != undefined ? (
                    <ShortCutMenuPopup
                      value={crData.customerCode}
                      menuItems={
                        <ul>
                          <li
                            className="shortcut-menu-item"
                            onClick={(e) =>
                              this.openCustomerOnOrderInq(
                                e,
                                crData.customerCode
                              )
                            }
                          >
                            {" "}
                            Customer On-Order{" "}
                          </li>
                          <li
                            className="shortcut-menu-item"
                            onClick={(e) =>
                              this.openCustomerTransactionsInq(
                                e,
                                crData.customerCode
                              )
                            }
                          >
                            {" "}
                            Customer Transactions{" "}
                          </li>
                          <li
                            className="shortcut-menu-item"
                            onClick={(e) =>
                              this.openCustomerStatisticsInq(
                                e,
                                crData.customerCode
                              )
                            }
                          >
                            {" "}
                            Customer Statistics{" "}
                          </li>
                          <li
                            className="shortcut-menu-item"
                            onClick={(e) =>
                              this.openCustomerSalesHistoryInq(
                                e,
                                crData.customerCode
                              )
                            }
                          >
                            {" "}
                            Customer Sales History{" "}
                          </li>
                          <li
                            className="shortcut-menu-item"
                            onClick={(e) =>
                              this.openCustomerMostRecentFabricsInq(
                                e,
                                crData.customerCode
                              )
                            }
                          >
                            {this.props.is3PL
                              ? "Customer Most Recent Items "
                              : "Customer Most Recent Fabrics"}{" "}
                          </li>
                          <li
                            className="shortcut-menu-item"
                            onClick={(e) =>
                              this.openCustomerCurrentAgingInq(
                                e,
                                crData.customerCode
                              )
                            }
                          >
                            {" "}
                            Customer Current Aging{" "}
                          </li>
                        </ul>
                      }
                    />
                  ) : null}
                </Col>
              </Col>
              <Col sm="2">
                <InputTextbox
                  ref={this.custCodeRef}
                  onChange={this.onCustomerCodeChange}
                  name="customerCode"
                  placeholder="Customer"
                  value={crData.customerCode}
                  lookupRequired={true}
                  lookupHandler={this.state.customerLookupHandler}
                  showCriteriaDialog={true}
                  enterKeyEventHandler={this.customerCodeEnterKeyEventHandler}
                  autoCompleteListData={
                    this.props.customerPageListForAutoCompleteList
                  }
                  enableAutoCompleteTextBox={true}
                  displayAutoCompleteList={this.displayAutoCustomerCompleteList}
                  showAutoCompleteList={
                    this.props.isShowAutoCompleteCustomerList
                  }
                  readOnly={disableCRFormFields}
                  disabled={disableCRFormFields}
                  isMandatory={true}
                />
              </Col>
              <Col sm="3">
                <InputTextbox
                  name="customerName"
                  type="text"
                  onChange={this.onChange}
                  readOnly={true}
                  value={crData.customerName}
                />{" "}
              </Col>
            </Row>
            <Row>
              <Col className="align-items-left" sm="1">
                <FormLabel>BillTo</FormLabel>
              </Col>
              <Col sm="2">
                <InputTextbox
                  name="billToCode"
                  onChange={this.onChange}
                  readOnly={true}
                  value={crData.billToCode}
                  isMandatory={true}
                />
              </Col>
              <Col className="align-items-left" sm="1">
                <FormLabel>Invoice#</FormLabel>
              </Col>
              <Col sm="2">
                <InputTextbox
                  ref={this.invCodeRef}
                  onChange={this.invoiceOnChange}
                  name="invoiceNumber"
                  placeholder="Enter Invoice"
                  value={crData.invoiceNumber}
                  lookupRequired={this.props.isShowInvoiceLookup}
                  lookupHandler={this.props.invoiceLookupHandler}
                  showCriteriaDialog={true}
                  enterKeyEventHandler={this.invoiceEnterKeyEvent}
                  autoCompleteListData={
                    this.props.invoicePageListForAutoCompleteList
                  }
                  enableAutoCompleteTextBox={true}
                  displayAutoCompleteList={this.displayInvoiceAutoCompleteList}
                  showAutoCompleteList={this.props.showAutoCompleteInvoiceList}
                  readOnly={disableCRFormFields}
                  disabled={disableCRFormFields}
                  isMandatory={true}
                />
              </Col>
              <Col className="align-items-left" sm="1">
                <FormLabel>CreditMemo Ref#</FormLabel>
              </Col>
              <Col sm="2">
                <NumberFormatInputbox
                  value={crData.creditMemoReferenceNumber}
                  onChange={this.onChange}
                  className="summary_input text-right"
                  name={"creditMemoReferenceNumber"}
                  disabled={true}
                />
              </Col>
            </Row>
            <Row>
              <Col sm="2">
                <Button
                  size="sm"
                  className="enterFocus"
                  id="fabric_Add_Button"
                  disabled={disableCRFetchFields}
                  onClick={(e) => this.fetchInvoiceOnClick(e)}
                >
                  FetchInvoice
                </Button>
              </Col>{" "}
            </Row>
          </div>

          <div className="div_Custom_4">
            <Table id="fabrics_tables">
              <thead>
                <tr>
                  <th>
                    <Button
                      size="sm"
                      onClick={(e) => this.openMerchandiseLineDetailDialog(e)}
                      id="fabric_Add_Button"
                    >
                      <AddIcon />
                    </Button>
                  </th>
                  <th
                    onClick={(e) =>
                      this.handleSortingMerchandiseChange(e, "fabricStyleCode")
                    }
                  >
                    {this.props.is3PL ? "Item" : "FabricStyle"}
                    {this.props.order === "desc" &&
                    this.props.sortField === "fabricStyleCode" ? (
                      <span className="drp-dwn-cntr">
                        <DropDwnUp />
                      </span>
                    ) : (
                      <span className="drp-dwn-cntr">
                        <DropDwnDown />
                      </span>
                    )}
                  </th>
                  <th
                    onClick={(e) =>
                      this.handleSortingMerchandiseChange(e, "fabricStyleName")
                    }
                  >
                    {this.props.is3PL ? "Item Name" : "FabricStyleName"}
                    {this.props.order === "desc" &&
                    this.props.sortField === "fabricStyleName" ? (
                      <span className="drp-dwn-cntr">
                        <DropDwnUp />
                      </span>
                    ) : (
                      <span className="drp-dwn-cntr">
                        <DropDwnDown />
                      </span>
                    )}
                  </th>
                  <th
                    onClick={(e) =>
                      this.handleSortingMerchandiseChange(e, "colorCode")
                    }
                  >
                    Color
                    {this.props.order === "desc" &&
                    this.props.sortField === "colorCode" ? (
                      <span className="drp-dwn-cntr">
                        <DropDwnUp />
                      </span>
                    ) : (
                      <span className="drp-dwn-cntr">
                        <DropDwnDown />
                      </span>
                    )}
                  </th>
                  <th
                    onClick={(e) =>
                      this.handleSortingMerchandiseChange(e, "uomCode")
                    }
                  >
                    UOM
                    {this.props.order === "desc" &&
                    this.props.sortField === "uomCode" ? (
                      <span className="drp-dwn-cntr">
                        <DropDwnUp />
                      </span>
                    ) : (
                      <span className="drp-dwn-cntr">
                        <DropDwnDown />
                      </span>
                    )}
                  </th>
                  <th
                    onClick={(e) =>
                      this.handleSortingMerchandiseChange(
                        e,
                        "lineTotalReturnQuantity"
                      )
                    }
                  >
                    TotalQty
                    {this.props.order === "desc" &&
                    this.props.sortField === "lineTotalReturnQuantity" ? (
                      <span className="drp-dwn-cntr">
                        <DropDwnUp />
                      </span>
                    ) : (
                      <span className="drp-dwn-cntr">
                        <DropDwnDown />
                      </span>
                    )}
                  </th>
                  <th
                    onClick={(e) =>
                      this.handleSortingMerchandiseChange(e, "price")
                    }
                  >
                    Price
                    {this.props.order === "desc" &&
                    this.props.sortField === "price" ? (
                      <span className="drp-dwn-cntr">
                        <DropDwnUp />
                      </span>
                    ) : (
                      <span className="drp-dwn-cntr">
                        <DropDwnDown />
                      </span>
                    )}
                  </th>
                  <th
                    onClick={(e) =>
                      this.handleSortingMerchandiseChange(e, "lineTotalAmount")
                    }
                  >
                    TotalAmt
                    {this.props.order === "desc" &&
                    this.props.sortField === "lineTotalAmount" ? (
                      <span className="drp-dwn-cntr">
                        <DropDwnUp />
                      </span>
                    ) : (
                      <span className="drp-dwn-cntr">
                        <DropDwnDown />
                      </span>
                    )}
                  </th>
                  <th
                    onClick={(e) =>
                      this.handleSortingMerchandiseChange(e, "invoiceNumber")
                    }
                  >
                    Invoice#
                    {this.props.order === "desc" &&
                    this.props.sortField === "invoiceNumber" ? (
                      <span className="drp-dwn-cntr">
                        <DropDwnUp />
                      </span>
                    ) : (
                      <span className="drp-dwn-cntr">
                        <DropDwnDown />
                      </span>
                    )}
                  </th>
                  <th></th>
                </tr>
              </thead>
              {merchandiseLineList != null ? (
                <tbody>
                  {merchandiseLineList.map((ln, index) => (
                    <tr key={index}>
                      <td>
                        <Button
                          variant="secondry"
                          className="hyperLinkText"
                          onClick={(e) =>
                            this.handleMerchandiseLineClick(
                              e,
                              ln.lineNumber,
                              ln
                            )
                          }
                        >
                          {ln.lineNumber}
                        </Button>
                      </td>
                      <td>{ln.fabricStyleCode}</td>
                      <td>{ln.fabricStyleName}</td>
                      <td>{ln.colorCode}</td>
                      <td>{ln.uomCode}</td>
                      <td className="text-right">
                        {ln.lineTotalReturnQuantity}
                      </td>
                      <td className="text-right">{ln.price}</td>
                      <td className="text-right">{ln.lineTotalAmount}</td>
                      <td>{ln.invoiceNumber}</td>
                      {this.props.isShowMercDelete && (
                        <td className="text-center">
                          <Button
                            onClick={(e) => this.deleteMerchandiseLine(e, ln)}
                          >
                            <DeleteIcon />
                          </Button>
                        </td>
                      )}
                    </tr>
                  ))}
                </tbody>
              ) : null}
            </Table>
            {merchandiseLineList.length != 0 ? null : (
              <div className="no_Data_small">{"NO DATA"}</div>
            )}
          </div>

          <div className="div_inline">
            <div className="div_70_no_overflow">
              <Row>
                <Col className="align-items-left" sm="1">
                  Remarks
                </Col>
                <Col>
                  <textarea
                    style={textAreaStyle}
                    className="form-control"
                    type="text"
                    name="comments"
                    value={crData.comments}
                    onChange={this.onChange}
                    disabled={disableCRFormFields}
                  />
                </Col>
              </Row>
            </div>
            <div className="div_30_no_overflow header_div">
              <Row>
                <Col>
                  <FormLabel>Amount Details</FormLabel>{" "}
                </Col>
              </Row>
              <Row>
                <Col>
                  <FormLabel>Total Return Amount</FormLabel>{" "}
                </Col>
                <Col>
                  <NumberFormatInputbox
                    value={crData.totalReturnAmount}
                    onChange={this.onChange}
                    className="summary_input text-right"
                    decimalScale={2}
                    name={"totalReturnAmount"}
                    disabled={true}
                  />
                </Col>
              </Row>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
class CustomerReturnHistoryDetailsForm extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
  }
  componentDidMount() {
    //
  }
  handleSortingStatusTrackChange = (e, accessor) => {
    if (e.detail === 1) this.props.handleSortingStatusTrackChange(accessor);
  };
  render() {
    let statusTrack = this.props.statusTrack;

    // let crData = this.props.crData;
    // let statusTracks = new Array();
    // statusTracks = crData.statusTracks;
    return (
      <div className="header_div">
        <div className="div_Custom_1">
          <Table id="fabrics_tables_default">
            <thead>
              <tr>
                <th
                  onClick={(e) =>
                    this.handleSortingStatusTrackChange(e, "createdDate")
                  }
                >
                  Date
                  {this.props.order === "desc" &&
                  this.props.sortField === "createdDate" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th
                  onClick={(e) =>
                    this.handleSortingStatusTrackChange(e, "totalReturnAmount")
                  }
                >
                  TotalCreditAmount
                  {this.props.order === "desc" &&
                  this.props.sortField === "totalReturnAmount" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th
                  onClick={(e) =>
                    this.handleSortingStatusTrackChange(e, "currentStatus")
                  }
                >
                  Status
                  {this.props.order === "desc" &&
                  this.props.sortField === "currentStatus" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th
                  onClick={(e) =>
                    this.handleSortingStatusTrackChange(e, "previousStatus")
                  }
                >
                  PreviousStatus
                  {this.props.order === "desc" &&
                  this.props.sortField === "previousStatus" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th
                  onClick={(e) =>
                    this.handleSortingStatusTrackChange(e, "createdBy")
                  }
                >
                  DoneBy
                  {this.props.order === "desc" &&
                  this.props.sortField === "createdBy" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
              </tr>
            </thead>
            {statusTrack != null ? (
              <tbody>
                {statusTrack.map((ln, index) => (
                  <tr key={index}>
                    <td>{ln.createdDate}</td>
                    <td>{ln.totalReturnAmount}</td>
                    <td>
                      {ModuleUtils.getCustomerReturnStatusCaption(
                        ln.currentStatus
                      )}
                    </td>

                    <td>
                      {ModuleUtils.getCustomerReturnStatusCaption(
                        ln.previousStatus
                      )}
                    </td>
                    <td>{ln.createdBy}</td>
                  </tr>
                ))}
              </tbody>
            ) : null}
          </Table>
          {statusTrack.length != 0 ? null : (
            <div className="no_Data">{"NO DATA"}</div>
          )}
        </div>
      </div>
    );
  }
}

function CustomerReturnModule(props) {
  return (
    <div id="moduleContainer" className="module_container">
      <div className="App">
        <CustomerReturn {...props} name="" /> <br />
      </div>
    </div>
  );
}

export default CustomerReturnModule;
